
var colorInfo = 
[ ["ARI","ARI Baja Blue","3d98c9","7688 C","100","std"],
["ARI","ARI Sandblast","b4ad96","400 C","100","std"],
["ARI","ARI Butterscotch","b38743","7556 C","95","std"],
["ARI","ARI Charcoal","4f5453","445 C","100","std"],
["ARI","ARI Light Charcoal","939c94","7538 C","100","std"], 
["ARI","ARI Galaxy Purple","1f004a","2765 C","100","std"],
["ARI","ARI Gunmetal Gray","535353","64,56,56,33","100","met"],
["ARI","ARI Raw Carbon","2c3238","447 C","90","std"],
["ARI","ARI Emerald","0d4b66","3165 C","90","std"],
["ARI","ARI Coral","e05e49","2027 C","80","std"],
["ARI","ARI Mistry Granite","646f73","Cool Gray 10","90","std"],
["ARI","ARI Mistry Granite Light","aeb2a9","Cool Gray 5 C","90","std"],
["ARI","ARI Ice Blue","e1ecec","649 C","75","std"],
["ARI","ARI Lush Green","0e5c16","7483 C","100","std"],
["ARI","ARI Smoke Gray","383838","447 C","85","std"],
["ARI","ARI Cherry Spark","7d0002","1815 C","80","std"],
["ARI","ARI Slate Blue","3a6882","7699 C","95","std"],
["ARI","ARI Olive","566150","7498 C","95","std"],
["ARI","ARI Gray","434c53","7540 C","95","std"],
["BETTER BOLTS","BB Silver","c1c6c8","Blank Silver Material","100","met"],
["BETTER BOLTS","BB Kash","9d662c","730 C","100","met"],
["BETTER BOLTS","BB Gold","f09935","2011 C","100","met"],
["BETTER BOLTS","BB Hot Pink","d8419d","3527 C","100","met"],
["BETTER BOLTS","BB Purple","61007b","3515 C","100","met"],
["BETTER BOLTS","BB Stealth Gray","6c7c7e","444 C","100","met"],
["BETTER BOLTS","BB Orange","fd3a20","Bright Red C","100","met"],
["BETTER BOLTS","BB Red","bf062f","200 C","100","met"],
["BETTER BOLTS","BB Pink","df878d","2445 C","100","met"],
["BETTER BOLTS","BB Cola","62322f","7630 C","100","met"],
["BETTER BOLTS","BB Green","00ae44","354 C","100","met"],
["BETTER BOLTS","BB Lime Green","40a040","7738 C","100","met"],
["BETTER BOLTS","BB Turquoise","00c08b","3395 C","100","met"],
["BETTER BOLTS","BB Dark Blue","002677","2147 C","100","met"],
["BETTER BOLTS","BB Blue","004e73","3025 C","100","met"],
["BIANCHI","Bianchi Celeste Blue","6ad9d4","3242c","90","std"],
["CANE CREEK","Cane Creek Gold","ffc62d","123c","100","met"],
["CHRIS KING","Chris King Soto Voce Violet","5f2268","2623c","60","met"],
["CHRIS KING","Chris King Midnight","233747","7546c","100","met"],
["CHRIS KING","Chris King Navy","00109e","072c","90","met"],
["CHRIS KING","Chris King Turquoise","0082cb","process blue c","100","met"],
["CHRIS KING","Chris King Red","d40036","206c","70","met"],
["CHRIS KING","Chris King Mango","d24520","173c","75","met"],
["CHRIS KING","BourbonChris King ","af6433","7566c","95","met"],
["CHRIS KING","Chris King Pewter","3f5464","7545c","100","met"],
["CHRIS KING","Chris King Slate","4d4a47","2336c","100","met"],
["CHROMAG","Chromag Gold","a17400","132c","100","met"],
["DEITY","Deity Silver Stem","c1c6c8","Silver material","90","met"],
["DEITY","Deity Orange Stem","c12027","3546 C","100","met"],
["DEITY","Deity Blue Stem","2662a9","3506 C","100","met"],
["DEITY","Deity Red Stem","c92539","199 C","100","met"],
["DEITY","Deity Platinum Stem","63665d","417 C","100","met"],
["DEITY","Deity Green Stem","5b9d4d","7738 C","100","met"],
["DEITY","Deity Purple Stem","7e1e76","2355 C","100","met"],
["DEITY","Deity Pedal Copper","8d5a2a","464c","100","met"],
["DEITY","Deity Stem Copper","653819","1545c","100","met"],
["DEITY","Deity HandleBar Blue","009cd1","81,21,5,0","100","std"],
["DEITY","Deity Grip Stealth","636569","Cool Gray 10 C","100","std"],
["DEITY","Deity Grip Orange","ff5300","021 C","100","std"],
["DEITY","Deity Grip Blue","0084d6","2173 C","100","std"],
["DEITY","Deity Grip Green","90c715","2292 C","100","std"],
["DEITY","Deity Grip Red","f32735","1788 C","100","std"],
["DEITY","Deity Grip Turquoise","00aac9","3125 C","100","std"],
["DEITY","Deity Grip Gum","b3865d","2317 C","100","std"],
["DEITY","Deity Grip Magenta","b01b84","241 C","100","std"],
["DEITY","Deity Grip Mint","73ddd3","3245 C","100","std"],
["DEITY","Deity Grip Purple","8a1a9b","2602 C","100","std"],
["DEITY","Deity Grip Yellow","fdda00","108 C","100","std"],
["DEITY","Deity Silver","bcb8b5","silver material","100","met"],
["DEITY","Deity Purple","7f32a7","527 C","85","std"],
["DVO","DVO Blue","0074c7","3005c","100","std"],
["DVO","DVO Green","7ebc00","376C","75","std"],
["DVO","DVO Brown","483d2c","7554 C","90","met"],
["ENVE","26 FRAY PERFECT PURPLE","4918a0","2091 D","90","met"],
["ENVE","26 FRAY BRITISH RACING GREEN","132f28","5535 C","95","std"],
["ENVE","26 FRAY CLEAR SMOKE,000000","RICH BLACK","100","std"],
["ENVE","ENVE ASH GRAY","53565B","Cool Gray 11 C","95","std"],
["ENVE","ASH GRAY LOGO","A3A6A9","COOL GRAY 6","95","std"],
["ENVE","ENVE Aegean Blue","154468","154468","100","met"],
["ENVE","ENVE Aegean Blue","154468","154468","100","std"],
["ENVE","ENVE Sand","b4ae9d","7535 C","100","std"],
["ENVE","ENVE Rim Color","252322","252322","100","std"],
["ENVE","ENVE Gold","887350","872 C","100","met"],
["ENVE","ENVE Dark Silver","51555a","Cool Gray 11 C","100","met"],
["ENVE","ENVE Sea Coral","f16661","178C","100","std"],
["ENVE","ENVE Teal Green","61bcad","7465C","100","std"],
["ENVE","ENVE Tangier Orange","d65c27","166C","100","std"],
["ENVE","ENVE Peach","f7b6ac","169 C","100","std"],
["ENVE","ENVE Arctic Blue","005db4","300 C","100","met"],
["ENVE","ENVE Atacama Yellow","eba934","130 C","100","std"],
["ENVE","ENVE Army Green","413e27","60,55,85,55","100","std"],
["ENVE","ENVE Vanilla","e8dbcf","7,12,17,0","100","std"],
["ENVE","ENVE Quicksand","a2937f","35,37,51,5","100","std"],
["ENVE","ENVE Kiwi Green","909471","50,35,68,0","100","std"],
["ENVE","ENVE Melancholy Blue","e5f3fc","10,0,0,0","100","std"],
["ENVE","ENVE Mars Red","dc4433","0,95,100,0","100","std"],
["ENVE","ENVE Arctic White","fdf4ef","0,4,4,0","100","std"],
["ENVE","ENVE 91' Blue","0088a8","95,30,25,0","100","std"],
["ENVE","ENVE Cavalry Blue","365a76","85,55,30,22","100","std"],
["ENVE","ENVE Vermillion Red","b63033","10,100,90,10","100","std"],
["ENVE","ENVE Raspberry Red","af3034","15,100,55,20","100","std"],
["ENVE","ENVE Caribbean Green","007372","100,30,55,15","100","std"],
["ENVE","ENVE British Racing Green","092222","91,65,70,70","100","std"],
["EVIL","EVIL Megalodon Blue","0093c9","639c","90","std"],
["EVIL","EVIL Toxic Slime Green","91d500","802c","90","std"],
["EVIL","EVIL Orange","fe4811","172c","95","std"],
["EVIL","EVIL Angry Dolphin","00c4b3","3265c","100","std"],
["EVIL","EVIL Muddy Waters","3b4444","446c","95","std"],
["EVIL","EVIL Drunken Olive","4e524a","418c","100","std"],
["EVIL","EVIL Coral Reefer","fd4338","Warm Red c","90","std"],
["EVIL","EVIL Baja Fog","8b8179","Warm Gray 8","100","std"],
["EVIL","EVIL Clay Porter","c46c60","7607c","100","std"],
["EXT","EXT Red","a13037","21,99,76,14","100","std"],
["EXT","EXT Gold","a29a86","46,40,54,27","100","std"],
["EXT","EXT Gold","a29a86","2327","100","met"],
["EXT","EXT BRONZE","685D42","2328","100","met"],
["FORBIDDEN","Dreadnought Blue Heat","009ade","2925 C","100","std"],
["FORBIDDEN","Dreadnought Blue Heat Logo","3b4444","446 C","100","std"],
["FORBIDDEN","Dreadnought Deep Space 9","0626a9","2736 C","90","std"],
["FORBIDDEN","Dreadnought Deep Space 9 Magenta Logo","e50695","Rhodamine Red C","100","std"],
["FORBIDDEN","Dreadnought Deep Space 9 Yogurt Logo","c9007b","233 C","100","std"],
["FORBIDDEN","Dreadnought Deep Space 9 Purple Logo","7f38b2","2048 C","100","std"],
["FORBIDDEN","Dreadnought V2 Fatty T Gray","51555a","Cool Gray 11 C","100","std"],
["FORBIDDEN","Dreadnought V2 Fatty Teal","57b6b2","7427 C","95","std"],
["FORBIDDEN","Dreadnought V2 Fatty T Mint Logo","b8e7ca","2253 C","90","std"],
["FORBIDDEN","Dreadnought V2 Bloody Sabbath Orangello","ffc846","1225 C","100","std"],
["FORBIDDEN","Dreadnought V2 Bloody Sabbath Roarnge","c10230","200 C","100","std"],
["FORBIDDEN","Druid Gloss Moss","cedfd7","621 C","85","std"],
["FORBIDDEN","Druid Gloss Moss Logo","7a868e","430 C","90","std"],
["FORBIDDEN","Druid Velvet","0f1b4d","2766 C","90","met"],
["FORBIDDEN","Druid Velvet Logo","5cb3e6","2915 C","95","std"],
["FORBIDDEN","Druid Cosmic Eggplant","1f1650","274 C","85","met"],
["FORBIDDEN","Druid Cosmic Eggplant Logo","fe4811","172 C","95","std"],
["FORBIDDEN","Druid V1 Mr. Brownstone","6d615a","Warm Gray 11 C","95","met"],
["FORBIDDEN","Druid V1 Mr. Brownstone Logo","c1c5a8","5308 C","90","met"],
["FORBIDDEN","Druid V1 Blue Steel","3b3836","Black 7 C","95","met"],
["FORBIDDEN","Druid V1 Blue Steel logo","19909b","2236 C","100","std"],
["FORBIDDEN","Druid V1 New Growth","759801","377 C","100","std"],
["FORBIDDEN","Druid V1 New Growth Logo","a6d920","2290 C","100","std"],
["FORBIDDEN","Druid V2 Spruce Almighy","739d90","624 C","95","std"],
["FORBIDDEN","Druid V2 Yellow Logo","f3cf40","129 C","100","std"],
["FORBIDDEN","Druid V2 Purple Logo","4918a0","2091 C","90","std"],
["FORBIDDEN","Druid V3 Mr. Greenthumb","3d441f","5747 C","90","std"],
["FORBIDDEN","Druid V3 Mr. Greenthumb Yellow Logo","f4e962","100 C","100","std"],
["FORBIDDEN","Druid V3 Lilac Summer Daze","ecd9ea","7436 C","85","std"],
["FORBIDDEN","Supernought Black","000000","Rich Black","100","std"],
["FORBIDDEN","Supernought White Logo","f6f7fb","2,1,0,0","100","std"],
["FORBIDDEN","Supernought Yellow Logo","fdda00","108 C","100","std"],
["FORBIDDEN","Supernought White ","f4f5f1","3,1,4,0","100","std"],
["FORBIDDEN","Supernought Goldenrod logo","cc8900","131 C","95","std"],
["FORBIDDEN","Supernought Red Logo","ea0029","185 C","100","std"],
["FORMULA","Formula Purple","544da0","2103 C","95","std"],
["FOX","FOX Pistachio","d0d8b6","2274 C","95","std"],
["FOX","FOX Battle Ship","cdcfce","Cool Gray 2 C","95","std"],
["FOX","FOX Root Beer","79403a","499 C","80","std"],
["FOX","FOX Gold","f8b46a","150 C","100","met"],
["FOX","FOX Dark Metallic Gray","7f9795","5497c","100","met"],
["FOX","FOX Light Silver","c7c8ca","25% K","100","met"],
["FOX","FOX Top Cap Blue","0080c5","med blue c","100","met"],
["FOX","FOX Factory Orange","ef5f17","021C","100","std"],
["FOX","FOX Kashima","6f5326","140c","100","met"],
["FOX","FOX Red","e80029","185c","95","std"],
["FOX","FOX Yellow","f9d615","yellow 012c","97","std"],
["HOPE","Hope Orange","e65303","166 C","95","std"],
["HOPE","Hope Metallic Orange","e65303","166 C","95","met"],
["HOPE","Hope Purple","7f32a7","527 C","100","std"],
["IBIS","Ibis Hakka MX Coal","25282a","426 C","95","std"],
["IBIS","Ibis DV9/Hakka MX Bone","dbd4c2","7527 C","100","std"],
["IBIS","Ibis DV9/Hakka Teal Logo","44797b","7475 C","100","std"],
["IBIS","Ibis DV9/Hakka MX Black Logo","3b3836","Black 7 C","100","std"],
["IBIS","Ibis DV9 V2 Mud","6a6463","2334 C","95","std"],
["IBIS","Ibis DV9 V2 Water Spout","a3cfda","629 C","90","std"],
["IBIS","Ibis DV9 V2 Grapdeade","60269e","267 C","90","std"],
["IBIS","Ibis DV9 V2 Grapeade Concentrate","2e1a46","2695 C","100","met"],
["IBIS","Ibis DV9 V2 Citron","d1db2f","389 C","90","std"],
["IBIS","Ibis Mojo HD Blue","6ad1e3","375 C","100","std"],
["IBIS","Ibis Mojo HD Neon Red","e1251b","485 C","85","std"],
["IBIS","Ibis Mojo HD Sriracha Red","c10230","200 C","80","std"],
["IBIS","Ibis Mojo HD Accent Blue","0091b3","632 C","95","std"],
["IBIS","Ibis Mojo 3 Red Savina","ba0c2f","186 C","90","std"],
["IBIS","Ibis Mojo 3 Shark Bite Teal","477a7b","7475 C","100","std"],
["IBIS","Ibis Mojo 3 Shark Bite Lite","75dad5","7471 C","100","std"],
["IBIS","Ibis Mojo 3 OrangeAde","ff5300","021 C","100","std"],
["IBIS","Ibis Mojo 3 Silver","73817e","8500 C","80","met"],
["IBIS","Ibis Mojo 4 Dirty Whiteboard/Chalk/Drywall","c9c9c4","428 C","100","std"],
["IBIS","Ibis Mojo 4 Denim Blue","294a59","7477 C","100","std"],
["IBIS","Ibis Mojo 4 Chalk Blue Logo","6db0c9","7458 C","100","std"],
["IBIS","Ibis Mojo 4 Orange Logo","df4602","1665 C","100","std"],
["IBIS","Ibis Mojo HD3 Green Machine","97d700","368 C","100","std"],
["IBIS","Ibis Mojo HD3 Dark Green Accent","0d7f44","348 C","100","std"],
["IBIS","Ibis Mojo HD4 Fireball","da291c","2035 C","80","std"],
["IBIS","Ibis Mojo HD4 Neon Red","e23e2f","179 C","85","std"],
["IBIS","Ibis Mojo HD4 Patron Silver","8a8d8f","Cool Gray 6","90","met"],
["IBIS","Ibis Mojo HD4 Green Accent","91d500","375 C","100","std"],
["IBIS","Ibis Mojo HD4 Green Accent","53575a","425 C","100","std"],
["IBIS","Ibis Mojo HD5 Brown Pow","7a7256","7497 C","100","std"],
["IBIS","Ibis Mojo HD5 Red","c10230","200 C","100","std"],
["IBIS","Ibis Oso NPS Green","88a99a","2457 C","90","std"],
["IBIS","Ibis Oso Pond Scum Green","5d7261","5615 C","95","std"],
["IBIS","Ibis Oso NPS Blue ","6a7f96","2165 C","90","std"],
["IBIS","Ibis Oso Dark Water","141e28","7547 C","95","std"],
["IBIS","Ibis Oso Warm Latte","d5d1cb","Warm Gray 1 C","95","std"],
["IBIS","Ibis Mojo HD5 Yellow","dddf00","396 C","100","std"],
["IBIS","Ibis Ripley V1 OG Orange","e65303","166 C","100","std"],
["IBIS","Ibis Ripley V1 Blue Accent","004a98","2945 C","95","std"],
["IBIS","Ibis Ripley V2 Vitamin P","e0e721","388 C","90","std"],
["IBIS","Ibis Ripley V2 Accent Green","9ea533","2305 C","90","std"],
["IBIS","Ibis Ripley V2 Ti-Ho Silver","6f6e6d","424 C","75","met"],
["IBIS","Ibis Ripley V4 Blue Steel","7c92a1","5425 C","100","std"],
["IBIS","Ibis Ripley V4 Matte Brap","2b2926","Pantone Black C","90","std"],
["IBIS","Ibis Ripley V4 Pondscum Green","738274","5625 C","100","std"],
["IBIS","Ibis Ripley V4 Metallic Gray","50555b","Cool Gray 11 C","95","met"],
["IBIS","Ibis Ripley V5 Drywall","d3d1c3","7527 C","100","std"],
["IBIS","Ibis Ripley V5 Stone","51534a","418 C","100","std"],
["IBIS","Ibis Ripley AF Matte Pewter","343936","447 C","100","std"],
["IBIS","Ibis Ripley AF Mustard Stain","ae9922","613 C","100","std"],
["IBIS","Ibis Ripley V5 Bad Apple","a91b2e","187 C","100","std"],
["IBIS","Ibis Ripley V5 Fresh Asphalt","343936","447 C","100","std"],
["IBIS","Ibis Ripmo V1 Blue","2b76a2","8203 C","90","std"],
["IBIS","Ibis Ripmo V1 Army Green","5d6539","3753 C","100","std"],
["IBIS","Ibis Ripmo V1 Orange Accents","fa7413","1505 C","100","std"],
["IBIS","Ibis Ripmo V1 Pool Chalk Blue","7db0c6","7458 C","100","std"],
["IBIS","Ibis Ripmo V2 Star Destroyer Gray","7c7e75","416 C","95","std"],
["IBIS","Ibis Ripmo V2 Stone","51534a","418 C","100","std"],
["IBIS","Ibis Ripmo V2 Dark Green Accent","343936","447 C","100","std"],
["IBIS","Ibis Ripmo V2 Bug Zapper Blue","00bfd3","3115 C","100","std"],
["IBIS","Ibis Ripmo V2 Dark Slate","1e4b5a","7477 C","100","std"],
["IBIS","Ibis Ripmo V3 Emerald Green","10312b","627 C","95","met"],
["IBIS","Ibis Ripmo V3 Light Green Logo","bbde1a","2297","100","std"],
["IBIS","Ibis Ripmo V4 Endurocell Gray","3b3836","Black 7 C","95","met"],
["IBIS","Ibis Ripmo V4 Endurocell Copper","a45b2a","470 C","95","met"],
["IBIS","Ibis Ripmo V4 Dank Avocado","3f4727","5743 C","95","std"],
["IBIS","Ibis Ripmo V4 40th Purple","57477b","3574 C","95","std"],
["IBIS","Ibis Ripmo V4 Lavender Hill Mob","9a90c6","2100 C","95","std"],
["IBIS","Ibis Ripmo V4 Astral Aura","2e334c","4154 C","95","std"],
["IBIS","Ibis Ripmo V4  Asphalt","353936","447 C","100","std"],
["IBIS","Ibis Ripmo V4 Silver","bcb8b5","silver material","100","met"],
["IBIS","Ibis Ripmo AF Red Savina","fc4c02","1655 C","100","std"],
["IBIS","Ibis Obsidian","352e2e","412 C","90","std"],
["IBIS","Ibis Blue Fog","a9bac7","5435 C","95","std"],
["IBIS","Ibis Tarnished Gold","887c62","2326 C","95","std"],
["INDUSTRY NINE","I9 Gold","f08900","144 C","98","met"],
["INDUSTRY NINE","I9 Bronze","8c5c30","2319 C","95","met"],
["INDUSTRY NINE","I9 Red","db0032","199 C","88","met"],
["INDUSTRY NINE","I9 True Green","00833e","348 C","100","met"],
["INDUSTRY NINE","I9 Dark Blue","002f87","287 C","95","met"],
["INDUSTRY NINE","I9 Purple","73308a","526 C","90","met"],
["INDUSTRY NINE","I9 Lime Green","38d430","802 C","80","met"],
["INDUSTRY NINE","I9 Orange","ff5c35","171 C","100","met"],
["INDUSTRY NINE","I9 Blue","008fbe","313 C","100","met"],
["INDUSTRY NINE","I9 Pink","d40054","Strong Red C","100","met"],
["INDUSTRY NINE","I9 Rim Match","000000","50,50,50,100","100","met"],
["INDUSTRY NINE","I9 Dark Gray","393d40","393d40","100","met"],
["INDUSTRY NINE","I9 Light Gray","879096","879096","100","met"],
["JULIANA","Furtado Matte Aquamarine","30637f","7699 C","90","std"],
["JULIANA","Furtado Pondscum Logo","71d77e","2268 C","90","std"],
["JULIANA","Furtado Matte Lavender Luster","bac4db","7450 C","80","std"],
["JULIANA","Furtado Yellow Logo","ffa400","137 C","100","std"],
["JULIANA","Furtado Matte Jade Green","41695b","5545 C","90","std"],
["JULIANA","Furtado Fog","d6d1c4","7527 C","95","std"],
["JULIANA","Furtado White Logo","ffffff","fffff","100","std"],
["JULIANA","Furtado Pinot","691c32","7421 C","100","std"],
["JULIANA","Furtado Mint Logo","b6ccc2","622 C","95","std"],
["JULIANA","Furtado Blue Raspberry","0080bb","640 C","100","std"],
["JULIANA","Furtado White Logo","fffff","fffff","100","std"],
["JULIANA","Furtado Spicy Redwood","c25131","7580 C","95","std"],
["JULIANA","Joplin Matte Matcha Green","d6e799","2281 C","80","std"],
["JULIANA","Joplin Gold Logo","776748","2328 C","95","std"],
["JULIANA","Joplin Rose","f5acb8","700 C","100","std"],
["JULIANA","Joplin Maritime Gray","6e7c7c","444 C","100","std"],
["JULIANA","Joplin Misty Blue","abcbd8","2204 C","85","std"],
["JULIANA","Joplin Ultraviolet","003595","661 C","85","std"],
["JULIANA","Joplin Brown Logo","b06533","7566 C","95","std"],
["JULIANA","Joplin Aquarius Green","44797b","7475 C","95","std"],
["JULIANA","Joplin Pink Logo","b26f75","2447 C","95","std"],
["JULIANA","Joplin Dijon","d29e0e","7555 C","100","std"],
["JULIANA","Joplin Sky Blue Logo","a8d9d6","7464 U","95","std"],
["JULIANA","Joplin Coral","ff595a","178 C","100","std"],
["JULIANA","Joplin White Logo","ffffff","ffffff","100","std"],
["JULIANA","Maverick Violet","635cc7","2725 C","80","std"],
["JULIANA","Maverick Light Mauve Logo","b49dbc","2078 C","90","std"],
["JULIANA","Maverick Matte Cider Logo","c09473","4655 C","95","std"],
["JULIANA","Maverick Commando Green","595b3c","7763 C","100","std"],
["JULIANA","Maverick Tan Logo","bc955c","465 C","95","std"],
["JULIANA","Maverick Hot Tomato","db001c","2035 C","100","std"],
["JULIANA","Maverick Eggplant Logo","3f3a60","5265 C","95","std"],
["JULIANA","Quincy Gypsum","a9989d","436 C","90","std"],
["JULIANA","Quincy Midnight Metallic Blue","002a3a","303 C","100","met"],
["JULIANA","Quincy Metallic Gold Logo","f09935","2011 C","85","met"],
["JULIANA","Roubion Lavender","d2a0b8","686 C","90","std"],
["JULIANA","Roubion Matte Jade Green","41695b","5545 C","100","std"],
["JULIANA","Roubion Sage Logo","91b6bb","5503 C","95","std"],
["JULIANA","Roubion Metallic Orange","8f3920","2443 C","80","met"],
["JULIANA","Roubion Black Logo","00000","00000","100","std"],
["JULIANA","Roubion Evergreen","00a19b","3272 C","95","std"],
["JULIANA","Roubion White Logo","ffffff","ffffff","100","std"],
["JULIANA","Roubion Matte Fuchia","e50695","Rhodamine Red C","100","std"],
["JULIANA","Roubion Ultraviolet Logo","4b4cb1","2367 C","85","std"],
["JULIANA","Roubion Maritime Gray","4b585a","445 C","100","std"],
["JULIANA","Roubion Mint Logo","b6ccc2","622 C","95","std"],
["JULIANA","Roubion Green Sage","91b6bb","5503 C","90","std"],
["JULIANA","Roubion Red Rust Logo","b45b38","7585 C","85","std"],
["JULIANA","Roubion Crocadile Green","41695b","5545 C","100","std"],
["JULIANA","Roubion Mint Logo","b6ccc2","622 C","95","std"],
["JULIANA","Strega Cerulean Blue","2a7de1","2727 C","95","std"],
["JULIANA","Strega Tan Logo","d29e0e","7555 C","95","std"],
["JULIANA","Strega Wicked Green","00ce7c","7479 C","85","std"],
["JULIANA","Strega Gold Logo","906929","7559 C","95","std"],
["JULIANA","Wilder Palisade Peach","efa693","487 C","95","std"],
["JULIANA","Wilder Gold Logo","6c5d35","7561 C","95","std"],
["JULIANA","Wilder Sunshine Yellow","fcd672","1215 C","100","std"],
["JULIANA","Wilder Bluebird Logo","1ecad3","319 C","100","std"],
["MAXXIS","Maxxis Red","e80029","185 C","100","std"],
["MAXXIS","Maxxis Gray","afb2b3","Cool Gray 5","100","std"],
["MAXXIS","Maxxis Yellow","eddb00","3965 C","100","std"],
["MAXXIS","Maxxis Orange","fe4811","172 C","100","std"],
["MAXXIS","Maxxis Gumwall","997611","126 C","100","std"],
["OHLINS","Decal yellow","f8d05d","112 C","100","std"],
["OHLINS","Coil Yellow","f5b728","7594 C","100","std"],
["ORBEA","Orbea Purple","472d4e","2622 C","95","std"],
["ORBEA","Orbea Lemon Yellow","d8c934","109 C","100","std"],
["ORBEA","Orbea Sky Blue","a5c9d5","318 C","100","std"],
["ORBEA","Orbea Electric Orange","ce8b42","2025 C","85","std"],
["ORBEA","Orbea Bright Red","b65834","Warm Red C","95","std"],
["ORBEA","Orbea Warm Orange","b95e21","1655 C","100","std"],
["ORBEA","Orbea Pure Red","914d25","173 C","100","std"],
["ORBEA","Orbea Fuchia","9f5085","3527 C","100","std"],
["ORBEA","Orbea Mint Green","aac2af","2246 C","90","std"],
["ORBEA","Orbea Valley Green","7da532","376 C","95","std"],
["ORBEA","Orbea Blue","4f5d96","2383 C","85","std"],
["ORBEA","Orbea Navy Blue","221547","273 C","80","std"],
["ORBEA","Orbea Continental Blue","26203c","3524 C","95","std"],
["ORBEA","Orbea Graphite","4f535b","431 C","96","std"],
["ORBEA","Orbea Silver","94979d","Silver Material","100","met"],
["ORBEA","Orbea Mouse Gray","77777a","Cool Gray 8 C","100","std"],
["ORBEA","Orbea Rize Red Gold","b1993c","2007 C","85","met"],
["ORBEA","Orbea Rize Carbon Blue","2d365e","7693 C","95","std"],
["ORBEA","Orbea Rize Iceberg Gray","979b93","7537 C","100","std"],
["ORBEA","Orbea Rize Gloss Moondust Blue","171e2a","303 C","100","std"],
["ORBEA","Orbea Rize Yellow Logo","dce26d","100 C","100","std"],
["ORBEA","Orbea Rize Baobob Brown","a87d49","7576 C","90","met"],
["ORBEA","Orbea Rize Matte Cosmic Brown","402a1e","483 C","100","met"],
["ORBEA","Orbea Rize Metallic Orange Logo","884d30","7619 C","100","met"],
["ORBEA","Orbea Rize Matte Metallic Mulberry","6d2a4e","234 C","95","met"],
["ORBEA","Orbea Rize Matte Black","201f1d","Ori","100","std"],
["ORBEA","Orbea Rize Metallic Warm Gray Logo","5c5455","437 C","90","met"],
["ORBEA","Orbea Leo Orange","8c6427","7414 C","90","std"],
["ORBEA","Orbea Lichen Green","859b8b","557 C","85","std"],
["PIVOT","Pivot Blue","009ade","2925 C","100","std"],
["PIVOT","Pivot Team Yellow","cdde00","389 C","90","std"],
["PIVOT","Shadowcat Slate","4c6b87","2167 C","85","std"],
["PIVOT","16 Les29 Orange","f32735","1788 C","100","std"],
["PIVOT","17 Switchblade Red","e1251b","485 C","100","std"],
["PIVOT","19 Firebird Clay Logo","737668","P 13-7 U","95","std"],
["PIVOT","19 Firebird Orange","f2533f","2017 C","100","std"],
["PIVOT","21 Switchblade Blue","1d69a2","2151 C","100","std"],
["PIVOT","21 Switchblade Blue Logo","004876","7693 C","100","std"],
["PIVOT","21 Switchblade Army Green","3f4727","5743 C","95","std"],
["PIVOT","21 Switchblade Gray","76777a","Cool Gray 9 C","95","std"],
["PIVOT","21 Shuttle LT Bass Boat Blue","00567d","308 C","100","met"],
["PIVOT","21 Shuttle LT Vault Blue","003349","2189 C","100","std"],
["PIVOT","21 Shuttle LT Chalk Blue","6d749a","108-4-U","90","std"],
["PIVOT","23 Firebird Silver","d9d8d6","SIlver Material","95","met"],
["PIVOT","23 Firebird Red Fade Logo","e1251b","485 C","100","std"],
["PIVOT","23 Firebird Yellow Fade Logo","ffa400","137 C","100","std"],
["PIVOT","Pivot Decal Light Gray ","d9d8d6","Cool Gray 1 C","95","std"],
["PIVOT","Shuttle V1 Frame Blue","ff6b00","541 C","100","std"],
["PIVOT","Shuttle V1 Orange Logo","003b71","1505 C","100","std"],
["PIVOT","21 Shuttle LT Logo Gray ","a3a7aa","Cool Gray 6 C","95","std"],
["PIVOT","21 Shuttle LT Light Green","34473e","626 C","100","std"],
["PIVOT","21 Shuttle LT Dark Green","153e35","567 C","100","std"],
["PIVOT","Mach 6 Boost Blue","005cb9","300 C","100","std"],
["PIVOT","Mach 6 Boost Slate Gray Logo","243746","7546 C","100","std"],
["PIVOT","Mach 6 Boost Gold Logo","ffab4d","804 C","100","std"],
["PIVOT","Les29 Green","73bc25","368 C","95","std"],
["PIVOT","Les29 Light Blue","5fd0df","310 C","90","std"],
["PIVOT","23 Point Frame Denim","27596c","2181 C","100","std"],
["PIVOT","23 Point Silver Logo","bbbbbb","Silver Material","100","met"],
["PIVOT","23 Point Sand Frame Color","b6b098","2181 C","85","std"],
["PIVOT","23 Point Brown Logo","3e3430","2479 C","100","std"],
["PIVOT","Pivot Orange","f2533f","2027 C","100","std"],
["PIVOT","Pivot Dangerfruit","9b2098","254 C","90","std"],
["PIVOT","Pivot Seafoam Green","badf95","7486 C","90","std"],
["PIVOT","Pivot Blue Ribbon","0047bb","2728 C","100","std"],
["PIVOT","Pivot Midnight Blue","003970","2165 C","100","std"],
["PIVOT","Pivot Slate Blue","53718b","2166 C","90","std"],
["PIVOT","Pivot Steele Blue","657f99","654 C","95","std"],
["PIVOT","Pivot Glacial Green","002a3a","303 C","100","std"],
["PIVOT","PIvot Northern Lights Green","6f8373","5625","90","std"],
["PIVOT","Pivot Desert Sage","a4bcb2","5585 X","90","std"],
["PIVOT","Pivot Mojave","d0cbbc","7534 C","85","std"],
["PNW COMPONENTS","PNW Purple","8f63cd","265 C","100","std"],
["PNW COMPONENTS","PNW Green","00ce7c","7479 C","100","std"],
["PNW COMPONENTS","PNW Tan","d3b8a8","481 C","85","std"],
["PNW COMPONENTS","PNW Teal","10cfc9","3252 C","100","std"],
["PNW COMPONENTS","PNW Blue","005cb9","300 C","95","std"],
["PNW COMPONENTS","PNW Red","e1251b","485 C","95","std"],
["PNW COMPONENTS","PNW Gray","94989b","Cool Gray 7 C","90","std"],
["RENTHAL","Renthal Gold","b49b57","16-0836 TCX","100","std"],
["REVEL","Revel Rascal T-1000","8a8b99","cool gray 8","90","met"],
["REVEL","Revel Sedona","bd6439","7583 C","85","std"],
["REVEL","Revel LYB Purple","704e94","266 C","90","std"],
["REVEL","Revel Johnny Green Jeans","003831","627 C","95","std"],
["REVEL","Revel De La Coal","25282a","Pantone Black C","100","std"],
["REVEL","Revel Rail Mint","32c1af","3265 C","100","std"],
["ROCKSHOX","Fork Red","b60522","3517 C","85","std"],
["ROCKSHOX","Sid Blue","4685c7","2143 C","95","std"],
["ROCKSHOX","Lyrik Green","505936","574 C","95","std"],
["ROCKSHOX","Zeb Slate","4b4f54","7450 C","80","std"],
["SANTA CRUZ","24 Blur Matte Silver","bcb8b5","silver material","100","met"],
["SANTA CRUZ","24 Blur Gloss Spring Green","add02e","2291 C","95","std"],
["SANTA CRUZ","24 Blur Red Logo","bb2c33","186 C","100","std"],
["SANTA CRUZ","24 Bronson Chalk White","edefec","11-4204 TCX","95","std"],
["SANTA CRUZ","24 Bronson Logo Yellow","d3aa1f","110 C","95","std"],
["SANTA CRUZ","24 Bronson Sockeye Salmon","bc653b","7583 C","100","std"],
["SANTA CRUZ","24 Bronson Avocado Logo","dfdfc5","12-0106 TCX","100","std"],
["SANTA CRUZ","24 Bullit Blue Logo","c7d8e6","545 C","85","std"],
["SANTA CRUZ","24 Bullit Matte Cider","a57d5e","4646 C","100","std"],
["SANTA CRUZ","24 Bullit Brown Logo","464032","7532 C","100","std"],
["SANTA CRUZ","24 Hightower 3 Cardinal Red","6f2b30","188 C","100","std"],
["SANTA CRUZ","24 Heckler Dark Pewter","352e2e","412 C","95","met"],
["SANTA CRUZ","24 Heckler Pink Logo","ecd4d7","698 C","95","std"],
["SANTA CRUZ","24 Heckler Matte Silver","bcb8b5","silver material","100","met"],
["SANTA CRUZ","24 Jackal 4.1 Bacon","813e23","7526 C","100","std"],
["SANTA CRUZ","24 Nomad Liquid Blue","282f61","2119 C","95","std"],
["SANTA CRUZ","24 Nomad Dark Red Logo","68323e","505 C","100","std"],
["SANTA CRUZ","24 Nomad Gloss Marigold","f6edc4","11-0617 TCX","90","std"],
["SANTA CRUZ","24 Nomad Burnt Orange Logo","d65c27","166 C","100","std"],
["SANTA CRUZ","24 Megatower Gloss Purple ","795673","5135 C","100","std"],
["SANTA CRUZ","24 Megatower Gloss Purple ","352e2e","440 C","100","std"],
["SANTA CRUZ","24 Megatower Gloss Carbon","353936","447 C","100","std"],
["SANTA CRUZ","24 Tallboy Green Logo","65bfb2","3258 C","100","std"],
["SANTA CRUZ","23 5010 V5 Gloss Red","d72d49","192 C","95","std"],
["SANTA CRUZ","23 5010 5 Matte Nickel","b3a99c","Warm Gray 5","100","met"],
["SANTA CRUZ","23 5010 5 Light Yellow Logo","eee8a5","600 C","100","std"],
["SANTA CRUZ","23 Hightower V3 Matte Evergreen","2f6454","3288 C","100","std"],
["SANTA CRUZ","23 Hightower V3 Orange Logo","f16661","178 C","100","std"],
["SANTA CRUZ","23 Hightower Translucent Purple","9a253f","178 C","85","std"],
["SANTA CRUZ","23 Hightower Green Logo","c6b55c","7751 C","95","std"],
["SANTA CRUZ","23 Heckler Avocado","cbe79e","2282 C","85","std"],
["SANTA CRUZ","23 Heckler Blue Logo","0091a7","7711 C","90","std"],
["SANTA CRUZ","23 Megatower V2 Matte Nickel","b3a99c","Warm Gray 5","90","met"],
["SANTA CRUZ","23 Megatower V2 Orange Logo","c3723a","1645 C","95","std"],
["SANTA CRUZ","23 Megatower V2 Translucent Blue","003a4a","548 C","100","std"],
["SANTA CRUZ","23 Megatower Green Logo","3c8d5f","3405 C","100","std"],
["SANTA CRUZ","23 Nomad 6 Gypsum","a5999c","436 C","100","std"],
["SANTA CRUZ","23 Nomad 6 Orange Logo","df3e3f","1788 C","100","std"],
["SANTA CRUZ","23 Tallboy Ultra Blue","004783","301 C","95","std"],
["SANTA CRUZ","23 Tallboy Pink Logo","d03691","225 C","95","std"],
["SANTA CRUZ","23 Tallboy Gloss Melon","e89345","715 C","95","std"],
["SANTA CRUZ","23 Tallboy Gloss Melon Logo","5161c2","2125 C","100","std"],
["SANTA CRUZ","22 5010 4 Stormbringer Purple","3b2b2e","Black 5 C","100","std"],
["SANTA CRUZ","22 Bronson 4 Paydirt Gold","eebd3e","7408 C","95","met"],
["SANTA CRUZ","22 Bronson 4 Gray","6d708a","2361 C","100","std"],
["SANTA CRUZ","22 Bronson 4 Gloss Moss","49402d","448 C","100","std"],
["SANTA CRUZ","22 Bronson Sockeye Salmon","f16661","178 C","100","std"],
["SANTA CRUZ","22 Bronson Pale Straw Logo","c7d3a9","580 C","100","std"],
["SANTA CRUZ","22 Bronson Blue","4f8ed7","279 C","100","std"],
["SANTA CRUZ","22 Chameleon Golden Yellow","f5b728","7549 C","100","std"],
["SANTA CRUZ","22 Chameleon Raspberry Logo","971d63","234 C","100","std"],
["SANTA CRUZ","22 Hightower 2 Gloss Carbon","352e2e","212 C","100","std"],
["SANTA CRUZ","22 Hightower 2 Matte Melon","f58546","11575 C","100","std"],
["SANTA CRUZ","22 Megatower Amarillo Yellow","eece5c","129 C","100","std"],
["SANTA CRUZ","22 Megatower Storm Gray","3b4457","2379 C","100","std"],
["SANTA CRUZ","22 Tallboy Flatte Earth","615c2a","581 C","100","std"],
["SANTA CRUZ","22 Tallboy Orange Logo","cf5124","1665 C","100","std"],
["SANTA CRUZ","22 Tallboy Gloss Aqua","84c2d4","630 C","100","std"],
["SANTA CRUZ","21 Blur Gloss Aqua","84c2d4","630 C","100","std"],
["SANTA CRUZ","21 Blur Yellow Logo","e1ab35","124 C","100","std"],
["SANTA CRUZ","21 Blur Gloss Carbon","352e2e","440 C","100","std"],
["SANTA CRUZ","21 5010 Loosely Blue","008695","321 C","100","std"],
["SANTA CRUZ","21 5010 Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","21 5010 Raspberry Sorbet","814248","697 C","100","std"],
["SANTA CRUZ","21 5010 Gray Logo","6f7c7d","444 C","100","std"],
["SANTA CRUZ","21 Blur Lavender","9295cd","271 C","100","std"],
["SANTA CRUZ","21 Blur Tangerine Logo","d14b3a","179 C","100","std"],
["SANTA CRUZ","21 Bronson Red Tide","9a564b","7524 C","100","std"],
["SANTA CRUZ","21 Bronson Yellow Logo","e1ab35","124 C","100","std"],
["SANTA CRUZ","21 Bronson Matte Olive","738274","5625 C","100","std"],
["SANTA CRUZ","21 Bronson Blue Logo","4a718a","7698 C","100","std"],
["SANTA CRUZ","21 Bullit 3 Matte Copper","624333","7602 C","95","met"],
["SANTA CRUZ","21 Bullit 3 Black Logo","000000","50,50,50,100","95","std"],
["SANTA CRUZ","21 Bullit 3 Gloss Lavender","9295cd","271 C","95","std"],
["SANTA CRUZ","21 Bullit 3 YellowJacket Logo","dfe351","389 C","95","std"],
["SANTA CRUZ","21 Chameleon AL Fog","d2d0c4","7527 C","100","std"],
["SANTA CRUZ","21 Chameleon AL Yellowjacket Logo","dfe351","389 C","100","std"],
["SANTA CRUZ","21 Chameleon AL Raspberry Sorbet","853939","492 C","100","std"],
["SANTA CRUZ","21 Chameleon AL Gray Logo","6f7c7d","444 C","100","std"],
["SANTA CRUZ","21 Chameleon C Bronze","744b35","7602 C","85","met"],
["SANTA CRUZ","21 Chameleon C Cyan Logo","00a4cb","312 C","100","std"],
["SANTA CRUZ","21 Chameleon C Gloss Carbon","352e2e","440 C","100","std"],
["SANTA CRUZ","21 Chameleon C Sage Logo","738274","5625 C","100","std"],
["SANTA CRUZ","21 Heckler Gloss Carbon","352e2e","440 C","100","std"],
["SANTA CRUZ","21 Heckler Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","21 Heckler Fog","d2d0c4","7527 C","100","std"],
["SANTA CRUZ","21 Heckler Yellowjacket Logo","dfe351","389 C","90","std"],
["SANTA CRUZ","21 Highball Ember","d14b3a","179 C","95","std"],
["SANTA CRUZ","21 Highball Gray Logo","3b4457","2379 C","100","std"],
["SANTA CRUZ","21 Hightower Smoke Gray","8d8f90","877 C plain silver material","95","std"],
["SANTA CRUZ","21 Hightower White Logo","f0ddcf","12-1107 TPX","95","std"],
["SANTA CRUZ","21 Hightower Ember","d14b3a","179 C","100","std"],
["SANTA CRUZ","21 Hightower Bronze","744b35","7602 C","100","met"],
["SANTA CRUZ","21 Jackal Green","275a7b","7700 C","100","std"],
["SANTA CRUZ","21 Jackal Fog Logo","d2d0c4","7527 C","100","std"],
["SANTA CRUZ","21 Megatower Storm Gray","3b4457","2379 C","100","std"],
["SANTA CRUZ","21 Megatower Mauve Logo","9e7f76","7614 C","100","std"],
["SANTA CRUZ","21 Megatower","eece5c","129 C","100","std"],
["SANTA CRUZ","21 Megatower","f0ddcf","12-1107 TPX","100","std"],
["SANTA CRUZ","21 Nomad Oxblood","3b2221","4975 C","95","std"],
["SANTA CRUZ","21 Nomad Gold Logo","bb956d","2313 C","85","met"],
["SANTA CRUZ","21 Nomad Adder Green","72bf39","2287 C","100","std"],
["SANTA CRUZ","21 Nomad Pink Logo","d13a91","225 C","100","std"],
["SANTA CRUZ","21 Stigmata Moonstone Blue","a4d8d8","324 C","100","std"],
["SANTA CRUZ","21 Stigmata White Logo","f0ddcf","12-1107 TPX","100","std"],
["SANTA CRUZ","21 Stigmata Midnight Green","004624","3537 C","80","std"],
["SANTA CRUZ","21 Stigmata Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","21 Tallboy Ivory","f0ddcf","12-1107 TPX","95","std"],
["SANTA CRUZ","21 Tallboy Gypsum Logo","a5999c","436 C","95","std"],
["SANTA CRUZ","21 Tallboy Gloss Carbon","352e2e","440 C","100","std"],
["SANTA CRUZ","21 V-10 Oxblood","3b2221","4975 C","80","std"],
["SANTA CRUZ","21 V-10 Fog","d2d0c4","7527 C","95","std"],
["SANTA CRUZ","20 5010 Robins Egg ","a2b7c0","2176 C","90","std"],
["SANTA CRUZ","20 5010 Orange Logo","c25131","7580 C","95","std"],
["SANTA CRUZ","20 5010 Dark Gray","62665c","417 C","100","std"],
["SANTA CRUZ","20 5010 Light Gray Logo","929990","7538 C","95","std"],
["SANTA CRUZ","20 Blur Gloss Aqua ","72c3d7","630 C","100","std"],
["SANTA CRUZ","20 Blur Yellow Logo","eaaa00","124 C","100","std"],
["SANTA CRUZ","20 Blur Gloss Carbon","343936","440 C","100","std"],
["SANTA CRUZ","20 Blur Aquarius Green Logo","44797b","7454 C","100","std"],
["SANTA CRUZ","20 Bronson Red Tide","a55247","7524 C","95","std"],
["SANTA CRUZ","20 Bronson Yellow Logo","eaaa00","124 C","100","std"],
["SANTA CRUZ","20 Bronson Matte Olive","6f8373","5625 C","95","std"],
["SANTA CRUZ","20 Bronson Blue Logo","3e728c","7698 C","100","std"],
["SANTA CRUZ","20 Chameleon C Bronze","6e5137","2321 C","100","met"],
["SANTA CRUZ","20 Chameleon C Blue Logo","00a6d0","312 C","95","std"],
["SANTA CRUZ","20 Chameleon C Gloss Carbon","2c2927","BLACK C","100","std"],
["SANTA CRUZ","20 Chameleon C Sage Green Logo","6f8373","5625 C","95","std"],
["SANTA CRUZ","20 Chameleon AL Orange","bf4f00","718 C","95","std"],
["SANTA CRUZ","20 Chameleon AL Sky Blue Logo","a2c5d3","551 C","95","std"],
["SANTA CRUZ","20 Chameleon AL Slate Blue","4a848d","5483 C","100","std"],
["SANTA CRUZ","20 Chameleon AL Bronze","6e5137","2321 C","95","met"],
["SANTA CRUZ","20 Chameleon AL Blue Logo","00a6d0","312 C","95","std"],
["SANTA CRUZ","20 Chameleon AL Gloss Black","2c2927","BLACK C","90","std"],
["SANTA CRUZ","20 Chameleon AL Olive Green Logo","6f8373","5625 C","100","std"],
["SANTA CRUZ","20 Heckler 8 Blackout","343936","447 C","95","std"],
["SANTA CRUZ","20 Heckler 8 Camel Logo","cda38a","7514 C","100","std"],
["SANTA CRUZ","20 Heckler 8 YellowJacket","dfe351","389 C","95","std"],
["SANTA CRUZ","20 Heckler 8 Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","20 Highball WC Blue","3499d9","2925 C","100","std"],
["SANTA CRUZ","20 Highball Gray Primer","939991","7538 C","100","std"],
["SANTA CRUZ","20 Hightower Highland Blue","18537a","2153 C","95","std"],
["SANTA CRUZ","20 Hightower Desert Tan","d3c9a5","4545 C","90","std"],
["SANTA CRUZ","20 Hightower Burnt Orange","b5573a","7580 C","90","std"],
["SANTA CRUZ","20 Jackal Silver","8d8f90","silver material","100","met"],
["SANTA CRUZ","20 Jackal Yellow Logo","eaaa00","124 C","90","std"],
["SANTA CRUZ","20 Megatower FS Green","84bc9c","2247 C","100","std"],
["SANTA CRUZ","20 Megatower Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","20 Megatower Blackout Black","353936","447 C","90","std"],
["SANTA CRUZ","20 Nomad Eggplant","473247","518 C","100","std"],
["SANTA CRUZ","20 Nomad Aquarius Green Logo","50787a","7475 C","95","std"],
["SANTA CRUZ","20 Nomad Carbon Black Gloss","353936","447 C","100","std"],
["SANTA CRUZ","20 Nomad White","d2d0c4","7527 C","95","std"],
["SANTA CRUZ","20 Stigmata Mustard","cb9f3a","7555 C","100","std"],
["SANTA CRUZ","20 Stigmata White Logo","d2d0c4","7527 C","95","std"],
["SANTA CRUZ","20 Stigmata Olive Green","6f8373","5625 C","100","std"],
["SANTA CRUZ","20 Stigmata Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","20 Tallboy Stormbringer Purple","3b2b2e","Black 5 C","90","std"],
["SANTA CRUZ","20 Tallboy Black Logo","000000","50,50,50,100","100","std"],
["SANTA CRUZ","20 Tallboy Rocksteady Yellow Logo","c7b45c","7751 C","95","std"],
["SANTA CRUZ","20 Tallboy YellowJacket Yellow Logo","d1db2f","389","90","std"],
["SANTA CRUZ","20 V-10 Battleship Gray","9da0a1","422 C","95","std"],
["SANTA CRUZ","20 V-10 White Logo","d2d0c4","7527 C","95","std"],
["SANTA CRUZ","19 Megatower Fry Sauce","e1bcaa","14-1314 TPX","90","std"],
["SPECIALIZED","Moto Green","91d500","375 C","100","std"],
["SPECIALIZED","Hypher Green","c2d500","382 C","95","std"],
["SPECIALIZED","Rocket Red","fd4338","Warm Red C","95","std"],
["SPECIALIZED","Acid Mint","34d5ae","3385 C","95","std"],
["SPECIALIZED","Acid Kiwi","a2d460","367 C","100","std"],
["SPECIALIZED","Acid Pink","e4447a","205 C","100","std"],
["SPECIALIZED","Storm Gray","4c748c","5404 C","100","std"],
["SPECIALIZED","NIce Blue","00aac9","3125 C","100","std"],
["SPECIALIZED","Acid Lava","d96c00","2019 C","100","std"],
["SPECIALIZED","Blue Ghost","345d9d","6684 C","100","std"],
["SPECIALIZED","Blue Ghost Fade","1e2722","Black 3 C","100","std"],
["SPECIALIZED","Satin Raspberry","9d3359","7534 C","100","std"],
["SPECIALIZED","Arctic Blue","adc8e8","658 C","85","std"],
["SPECIALIZED","Satin Blaze","ff9119","1495 C","100","std"],
["SPECIALIZED","Ice Blue","c5d6ea","657 C","80","std"],
["SPECIALIZED","Satin Doppio Metallic","241f14","54,67,80,69","95","met"],
["SPECIALIZED","Cobalt Blue","00339f","286 C","80","std"],
["SPECIALIZED","Satin Redwood","a15330","7586 C","100","std"],
["SPECIALIZED","Satin Brassy Yellow","ffc600","7548 C","95","std"],
["SPECIALIZED","Limestone","c5e896","2282 C","80","std"],
["SPECIALIZED","Satin Olive Green","b9bb16","7744 C","100","std"],
["SPECIALIZED","White Sage","b7c3b8","5565 C","100","std"],
["SPECIALIZED","Sage","375542","7736 C","95","std"],
["SPECIALIZED","Sand","d6c2b8","4765 C","90","std"],
["SPECIALIZED","Satin Redwood","b4221c","2350 C","95","std"],
["SPECIALIZED","Levo AL Spruce","bac7c6","5527 C","90","std"],
["SPECIALIZED","Silver Dust","b6b2b7","Silver Material","100","met"],
["SPECIALIZED","Birch","d6d1c4","7527 C","90","std"],
["SPECIALIZED","White Mountains","c9c4bd","Warm Gray 2 C","90","std"],
["SPECIALIZED","Taupe","81776f","Warm Gray 9 C","90","std"],
["SPECIALIZED","Prismatic Copper","c8602f","7583 C","100","std"],
["SPECIALIZED","Alpine Green Metallic","3c4541","73","48","62","32","100","std"],
["SPECIALIZED","Dusty Lilac","a86d88","7646 C","100","std"],
["SPECIALIZED","Gloss Sierras","a59e87","7536 C","95","std"],
["SPECIALIZED","Mojave","cdb788","7502 C","85","std"],
["SPECIALIZED","Cast Battleship","323e48","432 C","100","std"],
["SPECIALIZED","Dusty Turquoise","2c6d7a","2214 C","100","std"],
["SPECIALIZED","Mint","b5dbd2","556 C","85","std"],
["SPECIALIZED","Nordic Red","f4323f","Pantone Red 032 C","95","std"],
["SPECIALIZED","Specailized Red","ea0029","185 C","100","std"],
["SPECIALIZED","Dirty White","ededee","0","0","0","7","100","std"],
["SPECIALIZED","Filthy White","d9d8d6","Cool Gray 1 C","95","std"],
["SPECIALIZED","Charcoal","686058","405 C","90","std"],
["SPECIALIZED","Neon Blue","0084d6","2194 C","100","std"],
["SPECIALIZED","Vivid Pink","fb4a5d","1785 C","100","std"],
["SPECIALIZED","Electric Green","51c073","2256 C","100","std"],
["SPECIALIZED","Harvest Gold","b78b1e","7556 C","95","std"],
["SPECIALIZED","Alloy Levo Sage Metallic","5d7261","5165 C","100","std"],
["SPECIALIZED","Dove Gray","e5e5e5","7,5,5,0","100","std"],
["SPECIALIZED","Gloss White Sage","b6ccc2","622 C","95","std"],
["SPECIALIZED","Matte Silver","cccfce","Cool Gray 2 C on metallic materal","95","met"],
["SPECIALIZED","Deep Lake","415364","7545 C","100","std"],
["SPECIALIZED","Gloss Purple","a2afe3","2113 C","80","std"],
["SPECIALIZED","26 G4 LEVO Gold Burnt Bronze","6c6356","2472 C","100","met"],
["SPECIALIZED","26 G4 LEVO Doppio Logo","2F261E","Black 4C","100","met"],
["SPECIALIZED","26 G4 LEVO Gloss Glacial Metallic","A3BBBE","2472 C","95","met"],
["SPECIALIZED","26 G4 LEVO Silver Logo","A4ACAB","Silver Material","90","std"],
["STAN'S","Stan's Aqua","0098a7","320 C","100","std"],
["STAN'S","Stan's Blue","4685c7","2143 C","100","std"],
["STAN'S","Stan's Copper","915a51","2468 C","95","met"],
["STAN'S","Stan's Gray","545759","425 C","100","std"],
["STAN'S","Stan's Green","8cb930","376 C","95","std"],
["STAN'S","Stan's Orange","eb562e","172 C","95","std"],
["STAN'S","Stan's Purple","a232a5","253 C","100","std"],
["STAN'S","Stan's Red","e70000","2347 C","100","std"],
["STAN'S","Stan's White","ffffff","White","100","std"],
["TRANSITION","PBJ Aqua Blue","9fcfca","7464 C","90","std"],
["TRANSITION","PBJ Copper Logo","8d5a31","10369 C","95","std"],
["TRANSITION","PBJ Denim","323e48","432 C","95","std"],
["TRANSITION","PBJ Khaki","cc9f53","7407 C","85","std"],
["TRANSITION","PBJ Raw Steel Silver Logo","aeafb1","Silver Material","100","met"],
["TRANSITION","Patrol Alloy Blueberry","202945","533 C","95","std"],
["TRANSITION","Patrol Alloy Corral Blue","91b6bb","5503 C","90","std"],
["TRANSITION","Patrol Alloy Neon Teal","00c4b3","3265 C","95","std"],
["TRANSITION","Patrol Alloy Orange","ff5300","021 C","100","std"],
["TRANSITION","Patrol Metallic Silver","8c8c8a","8001 C","100","met"],
["TRANSITION","Patrol Sagebrush","7e7f73","416 C","95","std"],
["TRANSITION","Relay Carbon Gray Logo","a3a7aa","Cool Gray 6 C","100","std"],
["TRANSITION","Repeater Mossy Green","4e4a33","7771 C","95","std"],
["TRANSITION","Scout Desert Tan","b1a283","2324 C","90","std"],
["TRANSITION","Scout Midnight Blue","2e5372","2377 C","100","std"],
["TRANSITION","Scout Olive","7a7157","7497 C","100","std"],
["TRANSITION","Scout Slate Blue","4a636c","8502 C","100","met"],
["TRANSITION","Scout Alloy Metallic Bronze","96694c","867 C","100","met"],
["TRANSITION","Scout Alloy Metallic Gray","7c7879","8421 C","95","met"],
["TRANSITION","Scout Alloy Raspberry","a12b2a","7628 C","100","std"],
["TRANSITION","Sentinel Loam Gold","c7893e","7510 C","90","std"],
["TRANSITION","Sentinel Metallic Gold","976f33","8960 C","100","met"],
["TRANSITION","Sentinel Misty Green","93a496","5635 C","95","std"],
["TRANSITION","Sentinel Pinot","7f2629","1815 C","100","std"],
["TRANSITION","Sentinel Sunflower Yellow","ffa400","137 C","100","std"],
["TRANSITION","Smuggler Bone Gray","a3a7aa","Cool Gray 6 C","95","std"],
["TRANSITION","Smuggler Dark Bronze","676060","8423 C","95","met"],
["TRANSITION","Smuggler Espresso","514747","8601 C","90","met"],
["TRANSITION","Smuggler Gunmetal Black","2d2a26","Black C","100","met"],
["TRANSITION","Smuggler Orchid","882062","8843 C","95","std"],
["TRANSITION","Spire Gold","8a6e4b","873 C","85","met"],
["TRANSITION","Spire Hint of Blue","a5bac9","5435 C","85","std"],
["TRANSITION","Spire Huckleberry","3f3a60","5265 C","95","std"],
["TRANSITION","Spire Primer Gray","6e7c7c","444 C","90","std"],
["TRANSITION","Spire Red","e1251b","485 C","100","std"],
["TRANSITION","Spur Aqua","73ddd3","3245 C","95","std"],
["TRANSITION","Spur Black Powder","262626","10399 C","100","met"],
["TRANSITION","Spur Copper","544929","10363 C","95","met"],
["TRANSITION","Spur Deep Sea Green","025157","7476 C","100","std"],
["TRANSITION","Spur Gold","85754e","871 C","90","met"],
["TRANSITION","Spur Gunmetal","676060","8423 C","95","met"],
["TRANSITION","Spur Metallic Slate","608d9c","8241 C","95","met"],
["TRANSITION","TR Blue","0097ce","801 C","100","std"],
["TRANSITION","TR Gray ","76777a","Cool Gray 9 C","90","std"],
["TRANSITION","TR 11 Primer Blue","6e7c7c","444 C","90","std"],
["TREK","Trek Black","2d2a26","Black C","100","std"],
["TREK","Black Pearl","2d2a26","Black C","100","std"],
["TREK","Viper Red","ce0e2d","186 C","100","std"],
["TREK","Solid Charcoal","323e48","432 C","95","met"],
["TREK","Metallic Charcoal","636569","Cool Gray 10 C","90","met"],
["TREK","Trek White","ffffff","ffffff","100","std"],
["TREK","Crystal White","ffffff","ffffff","100","std"],
["TREK","Sinister Black","4a4f54","7540 C","95","std"],
["TREK","Quicksilver","8c9091","877 C","100","met"],
["TREK","Deep Dark Blue","051c2c","296 C","100","std"],
["TREK","Waterloo Blue","0082ca","Process Blue","100","std"],
["TREK","Waterloo Blue Pearl","0082ca","Process Blue","100","std"],
["TREK","Roarnge","ff4d00","1655 C","100","std"],
["TREK","Pinot Red","79242f","188 C","100","std"],
["TREK","Vice Pink","e31d93","225 C","95","std"],
["TREK","Pink Frosting","f97fb5","211 C","95","std"],
["TREK","Purple Lotus","722282","2603 C","90","std"],
["TREK","Sandstorm","a69b95","Warm Gray 6 C","95","std"],
["TREK","Shady Gray","9baeab","5507 C","90","std"],
["TREK","Dark Roast Black","483729","7533 C","95","std"],
["TREK","Olive Green","5d6339","7762 C","95","std"],
["TREK","Green-Light","00b451","7481 C","95","std"],
["TREK","Tour Yellow","ffcd00","116 C","100","std"],
["TREK","Battleship Blue","415364","7545 C","95","std"],
["TREK","Starship Blue","415364","7545C","95","std"],
["TREK","Dark Aquatic","004750","316 C","100","std"],
["TREK","California Sky Blue","00acd8","638 C","100","std"],
["TREK","Metallic Gunmetal","9da0a1","422 C","90","std"],
["TREK","Anthracite","636569","Cool Gray 10 C","90","std"],
["TREK","Era White","d6d1c4","7527 C","90","std"],
["TREK","Blonde","fcdf51","113 C","100","std"],
["TREK","Sprint Mint","b5dbd2","566 C","90","std"],
["TREK","Brittish Racing Green","163029","5535 C","100","std"],
["TREK","Pacific","243746","7546 C","100","std"],
["TREK","Coral Red","c93825","7626 C","100","std"],
["TREK","Cobra Blod","592e2c","7631 C","100","std"],
["TREK","Old Style","8a6e4b","873 C","95","met"],
["TREK","Gravel ","898a8d","Cool Gray 8 C","95","std"],
["TREK","Slate","636569","Cool Gray 10 C","95","std"],
["TREK","Cardinal","96262c","7622 C","100","std"],
["TREK","Infrared","f32735","1788 C","100","std"],
["TREK","Royal","004a98","2945 C","95","std"],
["TREK","Azure","3cb4e5","298 C","100","std"],
["TREK","Ultraviolet","5c67b2","2116 C","80","std"],
["TREK","Olive Gray","4e4a33","7771 C","90","std"],
["TREK","Miami Green","10cfc9","3252 C","95","std"],
["TREK","Lime","3dae2b","361 C","90","std"],
["TREK","Volt","c2d500","382 C","95","std"],
["TREK","Radioactive Red","e70000","2347 C","100","std"],
["TREK","Alpine Blue","006098","7691 C","100","std"],
["TREK","Nautical Navy","051c2c","296 C","100","std"],
["TREK","Volt V2","cdde00","389 C","95","std"],
["TREK","Aloha Green","93dacf","571 C","95","std"],
["TREK","Teal","007580","7714 C","95","std"],
["TREK","Mulberry","43273b","7449 C","100","std"],
["TREK","Magenta","d50057","Rubine Red","100","std"],
["TREK","Blush","f2bcd5","3595 C","90","std"],
["TREK","Quicksand","9a7e62","2470 C","95","std"],
["TREK","Marigold","ffad00","2010 C","100","std"],
["TREK","Purple Abyss","230871","2745 C","80","std"],
["TREK","Rose Gold","c2b7bc","2473 C","85","std"],
["TREK","Black Olive","4e4a33","7771 C","90","std"],
["TREK","Mulsanne Blue","003e52","3035 C","100","std"],
["TREK","Crimson","c10230","200 C","100","std"],
["TREK","Factory Orange","f18a00","144 C","100","std"],
["TREK","Lithium Gray","343936","447 C","100","std"],
["TREK","Dark Aquatic","004e59","3165 C","100","std"],
["TREK","Mercury","929990","7538 C","95","met"],
["TREK","Rage Red","a32035","201 C","100","std"],
["WOLFTOOTH","Black","000000","RICH BLACK","100","MET"],
["WOLFTOOTH","Raw Silver","AFAFAF","SILVER MATERIAL","100","MET"],
["WOLFTOOTH","Espresso","83705D","WARM GRAY 10 C","100","MET"],
["WOLFTOOTH","Olive","556B2F","574 C","100","MET"],
["WOLFTOOTH","Blue","0083DB","2945 C","100","MET"],
["WOLFTOOTH","Ultraviolet Purple","A41EE2","3515 C","100","MET"],
["WOLFTOOTH","Red","E03A3E","206 C","100","MET"],
["WOLFTOOTH","Orange","F5821F","1505 C","100","MET"],
["WOLFTOOTH","Gold","b78b20","7556 C","100","MET"],
["YETI","Classic Yeti Dusty Turquoise","00848e","2237 C","100","std"],
["YETI","22 Yeti Turquoise","0099a8","320 C","100","std"],
["YETI","24 Yeti Turquoise","00a5b5","1788 C","100","std"],
["YETI","Yeti Metallic Gray","7e7f73","416 C","90","met"],
["YETI","Yeti Yellow","f6e948","101 C","95","std"],
["YETI","Yeti Beti Coral","e00d5b","2040 C","100","std"],
["YETI","Yeti Storm","003e52","3035 C","100","std"],
["YETI","Yeti Spruce","007a8a","7713 C","100","std"],
["YETI","Yeti Lime","38d430","802 C","95","std"],
["YETI","Yeti Glacier","afe2e3","317 C","85","std"],
["YETI","Yeti Brick","d64123","7597 C","100","std"],
["YETI","Yeti Watermelon","f32735","1788 C","100","std"],
["YETI","Yeti Radium","a0e2ba","351 C","85","std"],
["YETI","Yeti Sangria","89264f","7435 C","95","met"],
["YETI","Yeti Sage","6bcdb2","338 C","90","std"],
["YETI","Yeti Cherry","8e1537","1955 C","90","std"],
["YETI","Yeti Dust","d9c79e","7501 C","95","std"],
["YETI","Yeti Blanco","d6d1ca","Warm Gray 1 C","100","std"],
["YETI","Yeti Brown","402020","4975 C","90","std"],
["YETI","Yeti Loch","a3bbc3","7542 C","90","std"],
["YETI","Yeti Rhino","6e7c7c","444 C","95","std"],
["YETI","Yeti Manjo","F19700","2013 C","100","std"],
["YT INDUSTRIES","YT Assault Green","678b73","2407 C","95","std"],
["YT INDUSTRIES","YT Liquid Metal","8e9c9c","443 C","95","met"],
["YT INDUSTRIES","YT Ghostship Blue","42a7c6","7702 C","100","std"],
["YT INDUSTRIES","YT Lava Red","e23e2f","179 C","100","std"],
["YT INDUSTRIES","YT Vlad Red","79242f","188 C","100","std"],
["YT INDUSTRIES","YT Capra Beige","cfd1b8","5803 U","100","std"],
["YT INDUSTRIES","YT Ghostship Green","a0b8ae","5595 U","100","std"],
["YT INDUSTRIES","YT Chalk White","dbd6d1","5727 U","100","std"],
["YT INDUSTRIES","YT Deep Petrol","007078","322 C","95","std"],
["YT INDUSTRIES","YT jeffsy Storm Gray","5b6670","431 C","95","std"],
["YT INDUSTRIES","YT Jeffsy Coral","f32735","1788 C","100","std"],
["YT INDUSTRIES","YT Blood Red","ea0029","185 C","100","std"],
["YT INDUSTRIES","YT Gore Red","b12028","7621 C","100","std"],
["YT INDUSTRIES","YT Fallout Yellow","cdde00","389 C","85","std"],
["YT INDUSTRIES","YT Blue Lagoon","0097ce","801 C","100","std"],
["YT INDUSTRIES","YT Capra Nox Blue","19d3c5","3255 C","95","std"],
["YT INDUSTRIES","YT Jeffsy Peanut Butter","965f36","4635 C","100","std"],
["YT INDUSTRIES","YT Sludge Green","b9bb16","7744 C","100","std"],
["YT INDUSTRIES","YT Deep Yellow","f4b223","7409 C","100","std"],
["YT INDUSTRIES","YT Arctic Blue","7a97ab","5425 C","100","std"], 
["PANTONE","White","FFFFFF","white","100","std"],
["PANTONE","Black","000000","black","100","std"],
["PANTONE","Yellow C","FEDD00","yellow C","100","std"],
["PANTONE","Yellow 012 C","FFD700","Yellow 012 C","100","std"],
["PANTONE","Orange 021 C","FE5000","Orange 021 C","100","std"],
["PANTONE","Warm Red C","F9423A","Warm Red C","100","std"],
["PANTONE","Red 032 C","EF3340","Red 032 C","100","std"],
["PANTONE","Rubine Red C","CE0058","Rubine Red C","100","std"],
["PANTONE","Rhodamine Red C","E10098","Rhodamine Red C","100","std"],
["PANTONE","Purple C","BB29BB","Purple C","100","std"],
["PANTONE","Violet C","440099","Violet C","90","std"],
["PANTONE","Blue 072 C","10069F","Blue 072 C","80","std"],
["PANTONE","Reflex Blue C","00188A","Reflex Blue C","50","std"],
["PANTONE","Process Blue C","0085CA","Process Blue C","100","std"],
["PANTONE","Green C","00AB84","Green C","90","std"],
["PANTONE","Black C","2D2926","Black C","100","std"],
["PANTONE","Yellow 0131 C","F2F0A1","Yellow 0131 C","100","std"],
["PANTONE","Red 0331 C","FCAEBB","Red 0331 C","100","std"],
["PANTONE","Magenta 0521 C","F1B2DC","Magenta 0521 C","100","std"],
["PANTONE","Violet 0631 C","BF9BDE","Violet 0631 C","100","std"],
["PANTONE","Blue 0821 C","74D1EA","Blue 0821 C","100","std"],
["PANTONE","Green 0921 C","9DE7D7","Green 0921 C","100","std"],
["PANTONE","Black 0961 C","9E978E","Black 0961 C","100","std"],
["PANTONE","801 C","009ACE","801 C","100","std"],
["PANTONE","802 C","44D62C","802 C","75","std"],
["PANTONE","803 C","FFE900","803 C","100","std"],
["PANTONE","804 C","FFAA4D","804 C","100","std"],
["PANTONE","805 C","FF7276","805 C","100","std"],
["PANTONE","806 C","FF3EB5","806 C","100","std"],
["PANTONE","807 C","EA27C2","807 C","100","std"],
["PANTONE","871 C","84754E","871 C","100","std"],
["PANTONE","872 C","85714D","872 C","100","std"],
["PANTONE","873 C","866D4B","873 C","100","std"],
["PANTONE","874 C","8B6F4E","874 C","100","std"],
["PANTONE","875 C","87674F","875 C","100","std"],
["PANTONE","876 C","8B634B","876 C","100","std"],
["PANTONE","877 C","8A8D8F","877 C","100","std"],
["PANTONE","Medium Yellow C","FFD900","Medium Yellow C","100","std"],
["PANTONE","Bright Orange C","FF5E00","Bright Orange C","100","std"],
["PANTONE","Bright Red C","F93822","Bright Red C","100","std"],
["PANTONE","Strong Red C","CE0056","Strong Red C","100","std"],
["PANTONE","Pink C","D62598","Pink C","100","std"],
["PANTONE","Medium Purple C","4E008E","Medium Purple C","85","std"],
["PANTONE","Dark Blue C","00239C","Dark Blue C","90","std"],
["PANTONE","Medium Blue C","0084CA","Medium Blue C","100","std"],
["PANTONE","Bright Green C","00B08B","Bright Green C","98","std"],
["PANTONE","Neutral Black C","222223","Neutral Black C","100","std"],
["PANTONE","100 C","F6EB61","100 C","100","std"],
["PANTONE","101 C","F7EA48","101 C","100","std"],
["PANTONE","102 C","FCE300","102 C","100","std"],
["PANTONE","103 C","C5A900","103 C","100","std"],
["PANTONE","104 C","AF9800","104 C","100","std"],
["PANTONE","105 C","897A27","105 C","100","std"],
["PANTONE","7401 C","F5E1A4","7401 C","100","std"],
["PANTONE","7402 C","ECD898","7402 C","100","std"],
["PANTONE","7403 C","EED484","7403 C","100","std"],
["PANTONE","7404 C","F4DA40","7404 C","100","std"],
["PANTONE","7405 C","F2CD00","7405 C","100","std"],
["PANTONE","7406 C","F1C400","7406 C","100","std"],
["PANTONE","7407 C","CBA052","7407 C","100","std"],
["PANTONE","106 C","F9E547","106 C","100","std"],
["PANTONE","107 C","FBE122","107 C","100","std"],
["PANTONE","108 C","FEDB00","108 C","100","std"],
["PANTONE","109 C","FFD100","109 C","100","std"],
["PANTONE","110 C","DAAA00","110 C","100","std"],
["PANTONE","111 C","AA8A00","111 C","100","std"],
["PANTONE","112 C","9C8412","112 C","100","std"],
["PANTONE","113 C","FAE053","113 C","100","std"],
["PANTONE","114 C","FBDD40","114 C","100","std"],
["PANTONE","115 C","FDDA24","115 C","100","std"],
["PANTONE","116 C","FFCD00","116 C","100","std"],
["PANTONE","117 C","C99700","117 C","100","std"],
["PANTONE","118 C","AC8400","118 C","100","std"],
["PANTONE","119 C","897322","119 C","100","std"],
["PANTONE","127 C","F3DD6D","127 C","100","std"],
["PANTONE","128 C","F3D54E","128 C","100","std"],
["PANTONE","129 C","F3D03E","129 C","100","std"],
["PANTONE","130 C","F2A900","130 C","100","std"],
["PANTONE","131 C","CC8A00","131 C","100","std"],
["PANTONE","132 C","A07400","132 C","100","std"],
["PANTONE","133 C","6C571B","133 C","100","std"],
["PANTONE","1205 C","F8E08E","1205 C","100","std"],
["PANTONE","1215 C","FBD872","1215 C","100","std"],
["PANTONE","1225 C","FFC845","1225 C","100","std"],
["PANTONE","1235 C","FFB81C","1235 C","100","std"],
["PANTONE","1245 C","C69214","1245 C","100","std"],
["PANTONE","1255 C","AD841F","1255 C","100","std"],
["PANTONE","1265 C","886B25","1265 C","100","std"],
["PANTONE","120 C","FBDB65","120 C","100","std"],
["PANTONE","121 C","FDD757","121 C","100","std"],
["PANTONE","122 C","FED141","122 C","100","std"],
["PANTONE","123 C","FFC72C","123 C","100","std"],
["PANTONE","124 C","EAAA00","124 C","100","std"],
["PANTONE","125 C","B58500","125 C","100","std"],
["PANTONE","126 C","9A7611","126 C","100","std"],
["PANTONE","7548 C","FFC600","7548 C","100","std"],
["PANTONE","7549 C","FFB500","7549 C","100","std"],
["PANTONE","7550 C","D19000","7550 C","100","std"],
["PANTONE","7551 C","B47E00","7551 C","100","std"],
["PANTONE","7552 C","73531D","7552 C","100","std"],
["PANTONE","7553 C","5A4522","7553 C","100","std"],
["PANTONE","7554 C","4B3D2A","7554 C","100","std"],
["PANTONE","7555 C","D29F13","7555 C","100","std"],
["PANTONE","7556 C","B78B20","7556 C","100","std"],
["PANTONE","7557 C","9F7D23","7557 C","100","std"],
["PANTONE","7558 C","967126","7558 C","100","std"],
["PANTONE","7559 C","8F6A2A","7559 C","100","std"],
["PANTONE","7560 C","7D622E","7560 C","100","std"],
["PANTONE","7561 C","6C5D34","7561 C","100","std"],
["PANTONE","134 C","FDD26E","134 C","100","std"],
["PANTONE","135 C","FFC658","135 C","100","std"],
["PANTONE","136 C","FFBF3F","136 C","100","std"],
["PANTONE","137 C","FFA300","137 C","100","std"],
["PANTONE","138 C","DE7C00","138 C","100","std"],
["PANTONE","139 C","AF6D04","139 C","100","std"],
["PANTONE","140 C","74531C","140 C","100","std"],
["PANTONE","1345 C","FDD086","1345 C","100","std"],
["PANTONE","1355 C","FFC56E","1355 C","100","std"],
["PANTONE","1365 C","FFB549","1365 C","100","std"],
["PANTONE","1375 C","FF9E1B","1375 C","100","std"],
["PANTONE","1385 C","D57800","1385 C","100","std"],
["PANTONE","1395 C","996017","1395 C","100","std"],
["PANTONE","1405 C","6E4C1E","1405 C","100","std"],
["PANTONE","141 C","F2C75C","141 C","100","std"],
["PANTONE","142 C","F1BE48","142 C","100","std"],
["PANTONE","143 C","F1B434","143 C","100","std"],
["PANTONE","144 C","ED8B00","144 C","100","std"],
["PANTONE","145 C","CF7F00","145 C","100","std"],
["PANTONE","146 C","A76D11","146 C","100","std"],
["PANTONE","147 C","715C2A","147 C","100","std"],
["PANTONE","7408 C","F6BE00","7408 C","100","std"],
["PANTONE","7409 C","F0B323","7409 C","100","std"],
["PANTONE","7410 C","FEAD77","7410 C","100","std"],
["PANTONE","7411 C","E6A65D","7411 C","100","std"],
["PANTONE","7412 C","D38235","7412 C","100","std"],
["PANTONE","7413 C","DC8633","7413 C","100","std"],
["PANTONE","7414 C","C16C18","7414 C","100","std"],
["PANTONE","7562 C","BD9B60","7562 C","100","std"],
["PANTONE","7563 C","D69A2D","7563 C","100","std"],
["PANTONE","7564 C","DB8A06","7564 C","100","std"],
["PANTONE","7565 C","CD7925","7565 C","100","std"],
["PANTONE","7566 C","AD6433","7566 C","100","std"],
["PANTONE","7567 C","89532F","7567 C","100","std"],
["PANTONE","7568 C","775135","7568 C","100","std"],
["PANTONE","7569 C","D78825","7569 C","100","std"],
["PANTONE","7570 C","D3832B","7570 C","100","std"],
["PANTONE","7571 C","C67D30","7571 C","100","std"],
["PANTONE","7572 C","B67233","7572 C","100","std"],
["PANTONE","7573 C","A7662B","7573 C","100","std"],
["PANTONE","7574 C","9E6A38","7574 C","100","std"],
["PANTONE","7575 C","835D32","7575 C","100","std"],
["PANTONE","712 C","FCC89B","712 C","100","std"],
["PANTONE","713 C","FDBE87","713 C","100","std"],
["PANTONE","714 C","FDAA63","714 C","100","std"],
["PANTONE","715 C","F68D2E","715 C","100","std"],
["PANTONE","716 C","EA7600","716 C","100","std"],
["PANTONE","717 C","D45D00","717 C","100","std"],
["PANTONE","718 C","BE4D00","718 C","100","std"],
["PANTONE","148 C","FECB8B","148 C","100","std"],
["PANTONE","149 C","FFC27B","149 C","100","std"],
["PANTONE","150 C","FFB25B","150 C","100","std"],
["PANTONE","151 C","FF8200","151 C","100","std"],
["PANTONE","152 C","E57200","152 C","100","std"],
["PANTONE","153 C","BE6A14","153 C","100","std"],
["PANTONE","154 C","9B5A1A","154 C","100","std"],
["PANTONE","155 C","EFD19F","155 C","100","std"],
["PANTONE","156 C","EFBE7D","156 C","100","std"],
["PANTONE","157 C","ECA154","157 C","100","std"],
["PANTONE","158 C","E87722","158 C","100","std"],
["PANTONE","159 C","CB6015","159 C","100","std"],
["PANTONE","160 C","A1561C","160 C","100","std"],
["PANTONE","161 C","603D20","161 C","100","std"],
["PANTONE","1485 C","FFAE62","1485 C","100","std"],
["PANTONE","1495 C","FF8F1C","1495 C","100","std"],
["PANTONE","1505 C","FF6900","1505 C","100","std"],
["PANTONE","1525 C","B94700","1525 C","100","std"],
["PANTONE","1535 C","94450B","1535 C","100","std"],
["PANTONE","1545 C","653819","1545 C","100","std"],
["PANTONE","1555 C","FFB990","1555 C","100","std"],
["PANTONE","1565 C","FFA06A","1565 C","100","std"],
["PANTONE","1575 C","FF7F32","1575 C","100","std"],
["PANTONE","1585 C","FF6A13","1585 C","100","std"],
["PANTONE","1595 C","D86018","1595 C","100","std"],
["PANTONE","1605 C","A65523","1605 C","100","std"],
["PANTONE","1615 C","8B4720","1615 C","100","std"],
["PANTONE","162 C","FFBE9F","162 C","100","std"],
["PANTONE","163 C","FF9D6E","163 C","100","std"],
["PANTONE","164 C","FF7F41","164 C","100","std"],
["PANTONE","165 C","FF671F","165 C","100","std"],
["PANTONE","166 C","E35205","166 C","100","std"],
["PANTONE","167 C","BE531C","167 C","100","std"],
["PANTONE","168 C","73381D","168 C","100","std"],
["PANTONE","7576 C","DB864E","7576 C","100","std"],
["PANTONE","7577 C","E07E3C","7577 C","100","std"],
["PANTONE","7578 C","DC6B2F","7578 C","100","std"],
["PANTONE","7579 C","DC582A","7579 C","100","std"],
["PANTONE","7580 C","C05131","7580 C","100","std"],
["PANTONE","7581 C","864A33","7581 C","100","std"],
["PANTONE","7582 C","674736","7582 C","100","std"],
["PANTONE","1625 C","FFA38B","1625 C","100","std"],
["PANTONE","1635 C","FF8D6D","1635 C","100","std"],
["PANTONE","1645 C","FF6A39","1645 C","100","std"],
["PANTONE","1655 C","FC4C02","1655 C","100","std"],
["PANTONE","1665 C","DC4405","1665 C","100","std"],
["PANTONE","1675 C","A9431E","1675 C","100","std"],
["PANTONE","1685 C","833921","1685 C","100","std"],
["PANTONE","169 C","FFB3AB","169 C","95","std"],
["PANTONE","170 C","FF8674","170 C","95","std"],
["PANTONE","171 C","FF5C39","171 C","95","std"],
["PANTONE","172 C","FA4616","172 C","95","std"],
["PANTONE","173 C","CF4520","173 C","95","std"],
["PANTONE","174 C","963821","174 C","100","std"],
["PANTONE","175 C","6B3529","175 C","100","std"],
["PANTONE","7583 C","C4622D","7583 C","100","std"],
["PANTONE","7584 C","BA5826","7584 C","100","std"],
["PANTONE","7585 C","AF5C37","7585 C","100","std"],
["PANTONE","7586 C","9E5330","7586 C","100","std"],
["PANTONE","7587 C","924C2E","7587 C","100","std"],
["PANTONE","7588 C","7B4D35","7588 C","100","std"],
["PANTONE","7589 C","5C4738","7589 C","100","std"],
["PANTONE","7590 C","D4B59E","7590 C","100","std"],
["PANTONE","7591 C","C07D59","7591 C","100","std"],
["PANTONE","7592 C","B15533","7592 C","100","std"],
["PANTONE","7593 C","9D432C","7593 C","100","std"],
["PANTONE","7594 C","7C3A2D","7594 C","100","std"],
["PANTONE","7595 C","6B3D2E","7595 C","100","std"],
["PANTONE","7596 C","5C3D31","7596 C","100","std"],
["PANTONE","7597 C","D14124","7597 C","95","std"],
["PANTONE","7598 C","BD472A","7598 C","95","std"],
["PANTONE","7599 C","B33D26","7599 C","95","std"],
["PANTONE","7600 C","8D3F2B","7600 C","100","std"],
["PANTONE","7601 C","83412C","7601 C","100","std"],
["PANTONE","7602 C","7B4931","7602 C","100","std"],
["PANTONE","7603 C","674230","7603 C","100","std"],
["PANTONE","7604 C","E4D5D3","7604 C","100","std"],
["PANTONE","7605 C","E1BBB4","7605 C","100","std"],
["PANTONE","7606 C","D6938A","7606 C","100","std"],
["PANTONE","7607 C","C26E60","7607 C","100","std"],
["PANTONE","7608 C","A4493D","7608 C","100","std"],
["PANTONE","7609 C","823B34","7609 C","100","std"],
["PANTONE","7610 C","683431","7610 C","100","std"],
["PANTONE","7611 C","DDBCB0","7611 C","100","std"],
["PANTONE","7612 C","CA9A8E","7612 C","100","std"],
["PANTONE","7613 C","BC8A7E","7613 C","100","std"],
["PANTONE","7614 C","A37F74","7614 C","100","std"],
["PANTONE","7615 C","866761","7615 C","100","std"],
["PANTONE","7616 C","6B4C4C","7616 C","100","std"],
["PANTONE","7617 C","583D3E","7617 C","100","std"],
["PANTONE","7520 C","EABEB0","7520 C","100","std"],
["PANTONE","7521 C","C09C83","7521 C","100","std"],
["PANTONE","7522 C","B46A55","7522 C","100","std"],
["PANTONE","7523 C","AB5C57","7523 C","100","std"],
["PANTONE","7524 C","A45248","7524 C","100","std"],
["PANTONE","7525 C","9A6A4F","7525 C","100","std"],
["PANTONE","7526 C","8A391B","7526 C","100","std"],
["PANTONE","489 C","ECC3B2","489 C","100","std"],
["PANTONE","488 C","ECBAA8","488 C","100","std"],
["PANTONE","487 C","EAA794","487 C","100","std"],
["PANTONE","486 C","E8927C","486 C","100","std"],
["PANTONE","485 C","DA291C","485 C","95","std"],
["PANTONE","484 C","9A3324","484 C","100","std"],
["PANTONE","483 C","653024","483 C","100","std"],
["PANTONE","176 C","FFB1BB","176 C","100","std"],
["PANTONE","177 C","FF808B","177 C","95","std"],
["PANTONE","178 C","FF585D","178 C","95","std"],
["PANTONE","179 C","E03C31","179 C","95","std"],
["PANTONE","180 C","BE3A34","180 C","95","std"],
["PANTONE","181 C","81312F","181 C","100","std"],
["PANTONE","1765 C","FFA3B5","1765 C","98","std"],
["PANTONE","1775 C","FF8DA1","1775 C","98","std"],
["PANTONE","1785 C","F8485E","1785 C","98","std"],
["PANTONE","1788 C","EE2737","1788 C","98","std"],
["PANTONE","1795 C","D22630","1795 C","98","std"],
["PANTONE","1805 C","AF272F","1805 C","98","std"],
["PANTONE","1815 C","7C2529","1815 C","100","std"],
["PANTONE","1767 C","FCAFC0","1767 C","100","std"],
["PANTONE","1777 C","FB637E","1777 C","98","std"],
["PANTONE","1787 C","F4364C","1787 C","98","std"],
["PANTONE","1797 C","CB333B","1797 C","98","std"],
["PANTONE","1807 C","A4343A","1807 C","98","std"],
["PANTONE","1817 C","643335","1817 C","100","std"],
["PANTONE","7618 C","C66E4E","7618 C","100","std"],
["PANTONE","7619 C","C04C36","7619 C","100","std"],
["PANTONE","7620 C","B7312C","7620 C","100","std"],
["PANTONE","7621 C","AB2328","7621 C","100","std"],
["PANTONE","7622 C","93272C","7622 C","100","std"],
["PANTONE","7623 C","8A2A2B","7623 C","100","std"],
["PANTONE","7624 C","802F2D","7624 C","100","std"],
["PANTONE","7625 C","E1523D","7625 C","100","std"],
["PANTONE","7626 C","C63527","7626 C","100","std"],
["PANTONE","7627 C","A72B2A","7627 C","100","std"],
["PANTONE","7628 C","9E2A2B","7628 C","100","std"],
["PANTONE","7629 C","6D3332","7629 C","100","std"],
["PANTONE","7630 C","633231","7630 C","100","std"],
["PANTONE","7631 C","572D2D","7631 C","100","std"],
["PANTONE","7415 C","E6BAA8","7415 C","100","std"],
["PANTONE","7416 C","E56A54","7416 C","100","std"],
["PANTONE","7417 C","E04E39","7417 C","100","std"],
["PANTONE","7418 C","CD545B","7418 C","100","std"],
["PANTONE","7419 C","B04A5A","7419 C","100","std"],
["PANTONE","7420 C","9B2242","7420 C","100","std"],
["PANTONE","7421 C","651D32","7421 C","100","std"],
["PANTONE","182 C","FABBCB","182 C","100","std"],
["PANTONE","183 C","FC9BB3","183 C","100","std"],
["PANTONE","184 C","F65275","184 C","98","std"],
["PANTONE","185 C","E4002B","185 C","98","std"],
["PANTONE","186 C","C8102E","186 C","98","std"],
["PANTONE","187 C","A6192E","187 C","98","std"],
["PANTONE","188 C","76232F","188 C","98","std"],
["PANTONE","196 C","ECC7CD","196 C","98","std"],
["PANTONE","197 C","E89CAE","197 C","98","std"],
["PANTONE","198 C","DF4661","198 C","98","std"],
["PANTONE","199 C","D50032","199 C","98","std"],
["PANTONE","200 C","BA0C2F","200 C","98","std"],
["PANTONE","201 C","9D2235","201 C","98","std"],
["PANTONE","202 C","862633","202 C","98","std"],
["PANTONE","189 C","F8A3BC","189 C","98","std"],
["PANTONE","190 C","F67599","190 C","98","std"],
["PANTONE","191 C","EF426F","191 C","98","std"],
["PANTONE","192 C","E40046","192 C","98","std"],
["PANTONE","193 C","BF0D3E","193 C","98","std"],
["PANTONE","194 C","9B2743","194 C","98","std"],
["PANTONE","195 C","782F40","195 C","98","std"],
["PANTONE","1895 C","F5B6CD","1895 C","98","std"],
["PANTONE","1905 C","F59BBB","1905 C","98","std"],
["PANTONE","1915 C","EF4A81","1915 C","98","std"],
["PANTONE","1925 C","E0004D","1925 C","98","std"],
["PANTONE","1935 C","C5003E","1935 C","98","std"],
["PANTONE","1945 C","A6093D","1945 C","98","std"],
["PANTONE","1955 C","8A1538","1955 C","98","std"],
["PANTONE","705 C","F5DADF","705 C","98","std"],
["PANTONE","706 C","F7CED7","706 C","98","std"],
["PANTONE","707 C","F9B5C4","707 C","98","std"],
["PANTONE","708 C","F890A5","708 C","98","std"],
["PANTONE","709 C","EF6079","709 C","98","std"],
["PANTONE","710 C","E03E52","710 C","98","std"],
["PANTONE","711 C","CB2C30","711 C","98","std"],
["PANTONE","698 C","F2D4D7","698 C","100","std"],
["PANTONE","699 C","F4C3CC","699 C","100","std"],
["PANTONE","700 C","F2ACB9","700 C","100","std"],
["PANTONE","701 C","E68699","701 C","100","std"],
["PANTONE","702 C","D25B73","702 C","100","std"],
["PANTONE","703 C","B83A4B","703 C","100","std"],
["PANTONE","704 C","9E2A2F","704 C","100","std"],
["PANTONE","203 C","ECB3CB","203 C","100","std"],
["PANTONE","204 C","E782A9","204 C","100","std"],
["PANTONE","205 C","E0457B","205 C","100","std"],
["PANTONE","206 C","CE0037","206 C","100","std"],
["PANTONE","207 C","A50034","207 C","100","std"],
["PANTONE","208 C","861F41","208 C","100","std"],
["PANTONE","209 C","6F263D","209 C","100","std"],
["PANTONE","210 C","F99FC9","210 C","100","std"],
["PANTONE","211 C","F57EB6","211 C","100","std"],
["PANTONE","212 C","F04E98","212 C","100","std"],
["PANTONE","213 C","E31C79","213 C","100","std"],
["PANTONE","214 C","CE0F69","214 C","100","std"],
["PANTONE","215 C","AC145A","215 C","100","std"],
["PANTONE","216 C","7D2248","216 C","100","std"],
["PANTONE","7422 C","F4CDD4","7422 C","100","std"],
["PANTONE","7423 C","E06287","7423 C","100","std"],
["PANTONE","7424 C","E24585","7424 C","100","std"],
["PANTONE","7425 C","B52555","7425 C","100","std"],
["PANTONE","7426 C","A4123F","7426 C","100","std"],
["PANTONE","7427 C","971B2F","7427 C","100","std"],
["PANTONE","7428 C","6A2C3E","7428 C","100","std"],
["PANTONE","7632 C","D6C9CA","7632 C","100","std"],
["PANTONE","7633 C","C4A4A7","7633 C","100","std"],
["PANTONE","7634 C","C16784","7634 C","100","std"],
["PANTONE","7635 C","C63663","7635 C","100","std"],
["PANTONE","7636 C","BC204B","7636 C","100","std"],
["PANTONE","7637 C","912F46","7637 C","100","std"],
["PANTONE","7638 C","7E2D40","7638 C","100","std"],
["PANTONE","217 C","EABEDB","217 C","100","std"],
["PANTONE","218 C","E56DB1","218 C","100","std"],
["PANTONE","219 C","DA1884","219 C","100","std"],
["PANTONE","220 C","A50050","220 C","100","std"],
["PANTONE","221 C","910048","221 C","100","std"],
["PANTONE","222 C","6C1D45","222 C","100","std"],
["PANTONE","7639 C","936D73","7639 C","100","std"],
["PANTONE","7640 C","934054","7640 C","100","std"],
["PANTONE","7641 C","8E2C48","7641 C","100","std"],
["PANTONE","7642 C","732E4A","7642 C","100","std"],
["PANTONE","7643 C","682d44","7643 C","100","std"],
["PANTONE","7644 C","582D40","7644 C","100","std"],
["PANTONE","7645 C","502B3A","7645 C","100","std"],
["PANTONE","223 C","EF95CF","223 C","100","std"],
["PANTONE","224 C","EB6FBD","224 C","100","std"],
["PANTONE","225 C","DF1995","225 C","100","std"],
["PANTONE","226 C","D0006F","226 C","100","std"],
["PANTONE","227 C","AA0061","227 C","100","std"],
["PANTONE","228 C","890C58","228 C","100","std"],
["PANTONE","229 C","672146","229 C","100","std"],
["PANTONE","230 C","F4A6D7","230 C","100","std"],
["PANTONE","231 C","F277C6","231 C","100","std"],
["PANTONE","232 C","E93CAC","232 C","100","std"],
["PANTONE","233 C","C6007E","233 C","100","std"],
["PANTONE","234 C","A20067","234 C","100","std"],
["PANTONE","235 C","840B55","235 C","100","std"],
["PANTONE","670 C","EAD3E2","670 C","100","std"],
["PANTONE","671 C","E6BCD8","671 C","100","std"],
["PANTONE","672 C","DFA0C9","672 C","100","std"],
["PANTONE","673 C","D986BA","673 C","100","std"],
["PANTONE","674 C","C6579A","674 C","100","std"],
["PANTONE","675 C","AE2573","675 C","100","std"],
["PANTONE","676 C","960051","676 C","100","std"],
["PANTONE","677 C","E5CEDB","677 C","100","std"],
["PANTONE","678 C","E3C8D8","678 C","100","std"],
["PANTONE","679 C","DEBED2","679 C","100","std"],
["PANTONE","680 C","C996B6","680 C","100","std"],
["PANTONE","681 C","B06C96","681 C","100","std"],
["PANTONE","682 C","994878","682 C","100","std"],
["PANTONE","683 C","7C2855","683 C","100","std"],
["PANTONE","684 C","E4C6D4","684 C","100","std"],
["PANTONE","685 C","DCB6C9","685 C","100","std"],
["PANTONE","686 C","D0A1BA","686 C","100","std"],
["PANTONE","687 C","BE84A3","687 C","100","std"],
["PANTONE","688 C","A76389","688 C","100","std"],
["PANTONE","689 C","893B67","689 C","100","std"],
["PANTONE","690 C","612141","690 C","100","std"],
["PANTONE","510 C","EBBECB","510 C","100","std"],
["PANTONE","509 C","E8B3C3","509 C","100","std"],
["PANTONE","508 C","E4A9BB","508 C","100","std"],
["PANTONE","507 C","D592AA","507 C","100","std"],
["PANTONE","506 C","84344E","506 C","100","std"],
["PANTONE","505 C","6F2C3F","505 C","100","std"],
["PANTONE","504 C","572932","504 C","100","std"],
["PANTONE","7429 C","E2BCCB","7429 C","100","std"],
["PANTONE","7430 C","DCA9BF","7430 C","100","std"],
["PANTONE","7431 C","C9809E","7431 C","100","std"],
["PANTONE","7432 C","B55C80","7432 C","100","std"],
["PANTONE","7433 C","A73A64","7433 C","100","std"],
["PANTONE","7434 C","9B3259","7434 C","100","std"],
["PANTONE","7435 C","872651","7435 C","100","std"],
["PANTONE","691 C","E9CDD0","691 C","100","std"],
["PANTONE","692 C","E4BEC3","692 C","100","std"],
["PANTONE","693 C","D7A3AB","693 C","100","std"],
["PANTONE","694 C","C48490","694 C","100","std"],
["PANTONE","695 C","B46B7A","695 C","100","std"],
["PANTONE","696 C","984856","696 C","100","std"],
["PANTONE","697 C","893C47","697 C","100","std"],
["PANTONE","496 C","F2C6CF","496 C","100","std"],
["PANTONE","495 C","F1BDC8","495 C","100","std"],
["PANTONE","494 C","E9A2B2","494 C","100","std"],
["PANTONE","493 C","DC8699","493 C","100","std"],
["PANTONE","492 C","8F3237","492 C","100","std"],
["PANTONE","491 C","7F3035","491 C","100","std"],
["PANTONE","490 C","5D2A2C","490 C","100","std"],
["PANTONE","503 C","E9C4C7","503 C","100","std"],
["PANTONE","502 C","E5BAC1","502 C","100","std"],
["PANTONE","501 C","DAA5AD","501 C","100","std"],
["PANTONE","500 C","C6858F","500 C","100","std"],
["PANTONE","499 C","7A3E3A","499 C","100","std"],
["PANTONE","498 C","6A3735","498 C","100","std"],
["PANTONE","497 C","512F2E","497 C","100","std"],
["PANTONE","5035 C","DFC2C3","5035 C","100","std"],
["PANTONE","5025 C","DBB7BB","5025 C","100","std"],
["PANTONE","5015 C","CCA1A6","5015 C","100","std"],
["PANTONE","5005 C","B07C83","5005 C","100","std"],
["PANTONE","4995 C","9C6169","4995 C","100","std"],
["PANTONE","4985 C","874B52","4985 C","100","std"],
["PANTONE","4975 C","3F2021","4975 C","100","std"],
["PANTONE","236 C","F1A7DC","236 C","100","std"],
["PANTONE","237 C","EC86D0","237 C","100","std"],
["PANTONE","238 C","E45DBF","238 C","100","std"],
["PANTONE","239 C","DB3EB1","239 C","100","std"],
["PANTONE","240 C","C5299B","240 C","100","std"],
["PANTONE","241 C","AF1685","241 C","100","std"],
["PANTONE","242 C","80225F","242 C","100","std"],
["PANTONE","2365 C","EFBAE1","2365 C","100","std"],
["PANTONE","2375 C","E277CD","2375 C","100","std"],
["PANTONE","2385 C","D539B5","2385 C","100","std"],
["PANTONE","2395 C","C800A1","2395 C","100","std"],
["PANTONE","2405 C","B0008E","2405 C","100","std"],
["PANTONE","2415 C","9E007E","2415 C","100","std"],
["PANTONE","2425 C","830065","2425 C","100","std"],
["PANTONE","243 C","EAB8E4","243 C","100","std"],
["PANTONE","244 C","E59BDC","244 C","100","std"],
["PANTONE","245 C","DD7FD3","245 C","100","std"],
["PANTONE","246 C","C724B1","246 C","100","std"],
["PANTONE","247 C","BB16A3","247 C","100","std"],
["PANTONE","248 C","A51890","248 C","100","std"],
["PANTONE","249 C","80276C","249 C","100","std"],
["PANTONE","7646 C","A56E87","7646 C","100","std"],
["PANTONE","7647 C","A83D72","7647 C","100","std"],
["PANTONE","7648 C","9D1D66","7648 C","100","std"],
["PANTONE","7649 C","8A1B61","7649 C","100","std"],
["PANTONE","7650 C","722257","7650 C","100","std"],
["PANTONE","7651 C","6A2A5B","7651 C","100","std"],
["PANTONE","7652 C","5E2751","7652 C","100","std"],
["PANTONE","250 C","E7BAE4","250 C","95","std"],
["PANTONE","251 C","DD9CDF","251 C","95","std"],
["PANTONE","252 C","C964CF","252 C","95","std"],
["PANTONE","253 C","AD1AAC","253 C","95","std"],
["PANTONE","254 C","981D97","254 C","95","std"],
["PANTONE","255 C","72246C","255 C","95","std"],
["PANTONE","517 C","EBC6DF","517 C","95","std"],
["PANTONE","516 C","E6BEDD","516 C","95","std"],
["PANTONE","515 C","E2ACD7","515 C","95","std"],
["PANTONE","514 C","D48BC8","514 C","95","std"],
["PANTONE","513 C","93328E","513 C","95","std"],
["PANTONE","512 C","833177","512 C","95","std"],
["PANTONE","511 C","612C51","511 C","95","std"],
["PANTONE","7436 C","EEDAEA","7436 C","95","std"],
["PANTONE","7437 C","CCAED0","7437 C","95","std"],
["PANTONE","7438 C","D59ED7","7438 C","95","std"],
["PANTONE","7439 C","B288B9","7439 C","95","std"],
["PANTONE","7440 C","A277A6","7440 C","95","std"],
["PANTONE","7441 C","9F5CC0","7441 C","95","std"],
["PANTONE","7442 C","963CBD","7442 C","95","std"],
["PANTONE","2562 C","D7A9E3","2562 C","95","std"],
["PANTONE","2572 C","C98BDB","2572 C","95","std"],
["PANTONE","2582 C","AC4FC6","2582 C","95","std"],
["PANTONE","2592 C","9B26B6","2592 C","95","std"],
["PANTONE","2602 C","87189D","2602 C","95","std"],
["PANTONE","2612 C","772583","2612 C","95","std"],
["PANTONE","2622 C","653165","2622 C","95","std"],
["PANTONE","7653 C","948794","7653 C","95","std"],
["PANTONE","7654 C","A2789C","7654 C","95","std"],
["PANTONE","7655 C","A15A95","7655 C","95","std"],
["PANTONE","7656 C","8E3A80","7656 C","95","std"],
["PANTONE","7657 C","6E2B62","7657 C","95","std"],
["PANTONE","7658 C","6A3460","7658 C","95","std"],
["PANTONE","7659 C","5D3754","7659 C","95","std"],
["PANTONE","524 C","D5C2D8","524 C","95","std"],
["PANTONE","523 C","C9B1D0","523 C","95","std"],
["PANTONE","522 C","BA9CC5","522 C","95","std"],
["PANTONE","521 C","A57FB2","521 C","95","std"],
["PANTONE","520 C","642F6C","520 C","95","std"],
["PANTONE","519 C","59315F","519 C","95","std"],
["PANTONE","518 C","4B3048","518 C","95","std"],
["PANTONE","5245 C","DBCDD3","5245 C","95","std"],
["PANTONE","5235 C","D0BEC7","5235 C","95","std"],
["PANTONE","5225 C","C6B0BC","5225 C","95","std"],
["PANTONE","5215 C","AF95A6","5215 C","95","std"],
["PANTONE","5205 C","86647A","5205 C","95","std"],
["PANTONE","5195 C","66435A","5195 C","95","std"],
["PANTONE","5185 C","4A3041","5185 C","95","std"],
["PANTONE","5175 C","D8C8D1","5175 C","95","std"],
["PANTONE","5165 C","D3C0CD","5165 C","95","std"],
["PANTONE","5155 C","BFA5B8","5155 C","95","std"],
["PANTONE","5145 C","9B7793","5145 C","95","std"],
["PANTONE","5135 C","7E5475","5135 C","95","std"],
["PANTONE","5125 C","693C5E","5125 C","95","std"],
["PANTONE","5115 C","512A44","5115 C","95","std"],
["PANTONE","531 C","DFC8E7","531 C","95","std"],
["PANTONE","530 C","D7B9E4","530 C","95","std"],
["PANTONE","529 C","CAA2DD","529 C","95","std"],
["PANTONE","528 C","B580D1","528 C","95","std"],
["PANTONE","527 C","8031A7","527 C","95","std"],
["PANTONE","526 C","702F8A","526 C","95","std"],
["PANTONE","525 C","572C5F","525 C","95","std"],
["PANTONE","256 C","D6BFDD","256 C","95","std"],
["PANTONE","257 C","C6A1CF","257 C","95","std"],
["PANTONE","258 C","8C4799","258 C","95","std"],
["PANTONE","259 C","6D2077","259 C","95","std"],
["PANTONE","260 C","642667","260 C","95","std"],
["PANTONE","261 C","5D285F","261 C","95","std"],
["PANTONE","262 C","51284F","262 C","95","std"],
["PANTONE","2563 C","CBA3D8","2563 C","95","std"],
["PANTONE","2573 C","B884CB","2573 C","95","std"],
["PANTONE","2583 C","A05EB5","2583 C","95","std"],
["PANTONE","2593 C","84329B","2593 C","95","std"],
["PANTONE","2603 C","702082","2603 C","95","std"],
["PANTONE","2613 C","5F2771","2613 C","95","std"],
["PANTONE","2623 C","5F2167","2623 C","95","std"],
["PANTONE","7660 C","9991A4","7660 C","95","std"],
["PANTONE","7661 C","8D6E97","7661 C","95","std"],
["PANTONE","7662 C","7A4183","7662 C","95","std"],
["PANTONE","7663 C","6B3077","7663 C","95","std"],
["PANTONE","7664 C","653279","7664 C","95","std"],
["PANTONE","7665 C","5E366E","7665 C","95","std"],
["PANTONE","7666 C","5C4E63","7666 C","95","std"],
["PANTONE","2567 C","C1A0DA","2567 C","95","std"],
["PANTONE","2577 C","A77BCA","2577 C","95","std"],
["PANTONE","2587 C","8246AF","2587 C","95","std"],
["PANTONE","2597 C","5C068C","2597 C","95","std"],
["PANTONE","2607 C","500778","2607 C","95","std"],
["PANTONE","2617 C","470A68","2617 C","95","std"],
["PANTONE","2627 C","3C1053","2627 C","95","std"],
["PANTONE","263 C","D7C6E6","263 C","95","std"],
["PANTONE","264 C","C1A7E2","264 C","95","std"],
["PANTONE","265 C","9063CD","265 C","95","std"],
["PANTONE","266 C","753BBD","266 C","95","std"],
["PANTONE","267 C","5F259F","267 C","95","std"],
["PANTONE","268 C","582C83","268 C","95","std"],
["PANTONE","269 C","512D6D","269 C","95","std"],
["PANTONE","2635 C","C5B4E3","2635 C","95","std"],
["PANTONE","2645 C","AD96DC","2645 C","95","std"],
["PANTONE","2655 C","9678D3","2655 C","95","std"],
["PANTONE","2665 C","7D55C7","2665 C","95","std"],
["PANTONE","2685 C","330072","2685 C","95","std"],
["PANTONE","2695 C","2E1A47","2695 C","95","std"],
["PANTONE","270 C","B4B5DF","270 C","95","std"],
["PANTONE","271 C","9595D2","271 C","95","std"],
["PANTONE","272 C","7474C1","272 C","95","std"],
["PANTONE","273 C","24135F","273 C","95","std"],
["PANTONE","274 C","211551","274 C","95","std"],
["PANTONE","275 C","201747","275 C","95","std"],
["PANTONE","276 C","221C35","276 C","95","std"],
["PANTONE","2705 C","A7A4E0","2705 C","95","std"],
["PANTONE","2715 C","8B84D7","2715 C","95","std"],
["PANTONE","2725 C","685BC7","2725 C","95","std"],
["PANTONE","2735 C","2E008B","2735 C","95","std"],
["PANTONE","2745 C","280071","2745 C","95","std"],
["PANTONE","2755 C","211261","2755 C","95","std"],
["PANTONE","2765 C","201547","2765 C","95","std"],
["PANTONE","7667 C","6E7CA0","7667 C","95","std"],
["PANTONE","7668 C","686E9F","7668 C","95","std"],
["PANTONE","7669 C","615E9B","7669 C","95","std"],
["PANTONE","7670 C","565294","7670 C","95","std"],
["PANTONE","7671 C","514689","7671 C","95","std"],
["PANTONE","7672 C","4C4184","7672 C","95","std"],
["PANTONE","7673 C","535486","7673 C","95","std"],
["PANTONE","7443 C","DDDAE8","7443 C","95","std"],
["PANTONE","7444 C","B6B8DC","7444 C","95","std"],
["PANTONE","7445 C","A7A2C3","7445 C","95","std"],
["PANTONE","7446 C","8986CA","7446 C","95","std"],
["PANTONE","7447 C","5D4777","7447 C","95","std"],
["PANTONE","7448 C","4B384C","7448 C","95","std"],
["PANTONE","7449 C","41273B","7449 C","95","std"],
["PANTONE","7674 C","878CB4","7674 C","95","std"],
["PANTONE","7675 C","7C7FAB","7675 C","95","std"],
["PANTONE","7676 C","7566A0","7676 C","95","std"],
["PANTONE","7677 C","6F5091","7677 C","95","std"],
["PANTONE","7678 C","68478D","7678 C","95","std"],
["PANTONE","7679 C","563D82","7679 C","95","std"],
["PANTONE","7680 C","523178","7680 C","95","std"],
["PANTONE","663 C","E5E1E6","663 C","100","std"],
["PANTONE","664 C","E0DBE3","664 C","100","std"],
["PANTONE","665 C","C6BCD0","665 C","100","std"],
["PANTONE","666 C","A192B2","666 C","100","std"],
["PANTONE","667 C","7C6992","667 C","100","std"],
["PANTONE","668 C","614B79","668 C","100","std"],
["PANTONE","669 C","3F2A56","669 C","100","std"],
["PANTONE","5315 C","D8D7DF","5315 C","100","std"],
["PANTONE","5305 C","C6C4D2","5305 C","100","std"],
["PANTONE","5295 C","B3B0C4","5295 C","100","std"],
["PANTONE","5285 C","8D89A5","5285 C","100","std"],
["PANTONE","5275 C","595478","5275 C","100","std"],
["PANTONE","5265 C","403A60","5265 C","100","std"],
["PANTONE","5255 C","1E1A34","5255 C","100","std"],
["PANTONE","538 C","C5CFDA","538 C","100","std"],
["PANTONE","537 C","BBC7D6","537 C","100","std"],
["PANTONE","536 C","A2B2C8","536 C","100","std"],
["PANTONE","535 C","8E9FBC","535 C","100","std"],
["PANTONE","534 C","1B365D","534 C","100","std"],
["PANTONE","533 C","1F2A44","533 C","100","std"],
["PANTONE","532 C","1C1F2A","532 C","100","std"],
["PANTONE","7541 C","D9E1E2","7541 C","100","std"],
["PANTONE","7542 C","A4BCC2","7542 C","100","std"],
["PANTONE","7543 C","98A4AE","7543 C","100","std"],
["PANTONE","7544 C","768692","7544 C","100","std"],
["PANTONE","7545 C","425563","7545 C","100","std"],
["PANTONE","7546 C","253746","7546 C","100","std"],
["PANTONE","7547 C","111E29","7547 C","100","std"],
["PANTONE","552 C","B9D3DC","552 C","100","std"],
["PANTONE","551 C","A3C7D2","551 C","100","std"],
["PANTONE","550 C","8DB9CA","550 C","100","std"],
["PANTONE","549 C","6BA4B8","549 C","100","std"],
["PANTONE","548 C","003D4C","548 C","100","std"],
["PANTONE","547 C","00313C","547 C","100","std"],
["PANTONE","546 C","072B31","546 C","100","std"],
["PANTONE","5455 C","BFCED6","5455 C","100","std"],
["PANTONE","5445 C","B7C9D3","5445 C","100","std"],
["PANTONE","5435 C","A6BBC8","5435 C","100","std"],
["PANTONE","5425 C","7A99AC","5425 C","100","std"],
["PANTONE","5415 C","5B7F95","5415 C","100","std"],
["PANTONE","5405 C","4F758B","5405 C","100","std"],
["PANTONE","5395 C","081F2C","5395 C","100","std"],
["PANTONE","642 C","D1DDE6","642 C","100","std"],
["PANTONE","643 C","C6D6E3","643 C","100","std"],
["PANTONE","644 C","9BB8D3","644 C","100","std"],
["PANTONE","645 C","7DA1C4","645 C","100","std"],
["PANTONE","646 C","5E8AB4","646 C","100","std"],
["PANTONE","647 C","236192","647 C","100","std"],
["PANTONE","648 C","002E5D","648 C","100","std"],
["PANTONE","649 C","DBE2E9","649 C","100","std"],
["PANTONE","650 C","CED9E5","650 C","100","std"],
["PANTONE","651 C","A7BCD6","651 C","100","std"],
["PANTONE","652 C","7D9BC1","652 C","100","std"],
["PANTONE","653 C","326295","653 C","100","std"],
["PANTONE","654 C","003A70","654 C","100","std"],
["PANTONE","655 C","002454","655 C","100","std"],
["PANTONE","656 C","DDE5ED","656 C","100","std"],
["PANTONE","657 C","C8D8EB","657 C","100","std"],
["PANTONE","658 C","B1C9E8","658 C","100","std"],
["PANTONE","659 C","7BA4DB","659 C","100","std"],
["PANTONE","660 C","407EC9","660 C","100","std"],
["PANTONE","661 C","003593","661 C","100","std"],
["PANTONE","662 C","001A70","662 C","100","std"],
["PANTONE","7450 C","BDC5DB","7450 C","100","std"],
["PANTONE","7451 C","89ABE3","7451 C","100","std"],
["PANTONE","7452 C","8094DD","7452 C","100","std"],
["PANTONE","7453 C","7BA6DE","7453 C","100","std"],
["PANTONE","7454 C","5F8FB4","7454 C","100","std"],
["PANTONE","7455 C","3A5DAE","7455 C","100","std"],
["PANTONE","7456 C","606EB2","7456 C","100","std"],
["PANTONE","2706 C","CBD3EB","2706 C","100","std"],
["PANTONE","2716 C","9FAEE5","2716 C","100","std"],
["PANTONE","2726 C","485CC7","2726 C","100","std"],
["PANTONE","2736 C","1E22AA","2736 C","100","std"],
["PANTONE","2746 C","171C8F","2746 C","100","std"],
["PANTONE","2756 C","151F6D","2756 C","100","std"],
["PANTONE","2766 C","141B4D","2766 C","100","std"],
["PANTONE","2708 C","B8CCEA","2708 C","100","std"],
["PANTONE","2718 C","5C88DA","2718 C","100","std"],
["PANTONE","2728 C","0047BB","2728 C","100","std"],
["PANTONE","2738 C","06038D","2738 C","100","std"],
["PANTONE","2748 C","001A70","2748 C","100","std"],
["PANTONE","2758 C","001F61","2758 C","100","std"],
["PANTONE","2768 C","071D49","2768 C","100","std"],
["PANTONE","2707 C","C3D7EE","2707 C","100","std"],
["PANTONE","2717 C","A7C6ED","2717 C","100","std"],
["PANTONE","2727 C","307FE2","2727 C","100","std"],
["PANTONE","2747 C","001A72","2747 C","100","std"],
["PANTONE","2757 C","001E60","2757 C","100","std"],
["PANTONE","2767 C","13294B","2767 C","100","std"],
["PANTONE","277 C","ABCAE9","277 C","100","std"],
["PANTONE","278 C","8BB8E8","278 C","100","std"],
["PANTONE","279 C","418FDE","279 C","100","std"],
["PANTONE","280 C","12169","280 C","100","std"],
["PANTONE","281 C","00205B","281 C","100","std"],
["PANTONE","282 C","001E43","282 C","100","std"],
["PANTONE","283 C","92C1E9","283 C","100","std"],
["PANTONE","284 C","6CACE4","284 C","100","std"],
["PANTONE","285 C","0072CE","285 C","100","std"],
["PANTONE","286 C","0033A0","286 C","100","std"],
["PANTONE","287 C","003088","287 C","100","std"],
["PANTONE","288 C","002D72","288 C","100","std"],
["PANTONE","289 C","0C2340","289 C","100","std"],
["PANTONE","7681 C","94A9CB","7681 C","100","std"],
["PANTONE","7682 C","6787B7","7682 C","100","std"],
["PANTONE","7683 C","426DA9","7683 C","100","std"],
["PANTONE","7684 C","385E9D","7684 C","100","std"],
["PANTONE","7685 C","2C5697","7685 C","100","std"],
["PANTONE","7686 C","1D4F91","7686 C","100","std"],
["PANTONE","7687 C","1D428A","7687 C","100","std"],
["PANTONE","545 C","C6DAE7","545 C","100","std"],
["PANTONE","544 C","BDD6E6","544 C","100","std"],
["PANTONE","543 C","A4C8E1","543 C","100","std"],
["PANTONE","542 C","7BAFD4","542 C","100","std"],
["PANTONE","541 C","003C71","541 C","100","std"],
["PANTONE","540 C","002F57","540 C","100","std"],
["PANTONE","539 C","00263A","539 C","100","std"],
["PANTONE","290 C","B9D9EB","290 C","100","std"],
["PANTONE","291 C","9BCBEB","291 C","100","std"],
["PANTONE","292 C","69B3E7","292 C","100","std"],
["PANTONE","293 C","003DA5","293 C","100","std"],
["PANTONE","294 C","002F6C","294 C","100","std"],
["PANTONE","295 C","002755","295 C","100","std"],
["PANTONE","296 C","041C2C","296 C","100","std"],
["PANTONE","2905 C","8DC8E8","2905 C","100","std"],
["PANTONE","2915 C","62B5E5","2915 C","100","std"],
["PANTONE","2925 C","009CDE","2925 C","100","std"],
["PANTONE","2935 C","0057B8","2935 C","100","std"],
["PANTONE","2945 C","004C97","2945 C","100","std"],
["PANTONE","2955 C","003866","2955 C","100","std"],
["PANTONE","2965 C","00263E","2965 C","100","std"],
["PANTONE","297 C","71C5E8","297 C","100","std"],
["PANTONE","298 C","41B6E6","298 C","100","std"],
["PANTONE","299 C","00A3E0","299 C","100","std"],
["PANTONE","300 C","005EB8","300 C","100","std"],
["PANTONE","301 C","004B87","301 C","100","std"],
["PANTONE","302 C","003B5C","302 C","100","std"],
["PANTONE","303 C","002A3A","303 C","100","std"],
["PANTONE","7688 C","4698CB","7688 C","100","std"],
["PANTONE","7689 C","298FC2","7689 C","100","std"],
["PANTONE","7690 C","0076A8","7690 C","100","std"],
["PANTONE","7691 C","006098","7691 C","100","std"],
["PANTONE","7692 C","005587","7692 C","100","std"],
["PANTONE","7693 C","004775","7693 C","100","std"],
["PANTONE","7694 C","01426A","7694 C","100","std"],
["PANTONE","2975 C","99D6EA","2975 C","100","std"],
["PANTONE","2985 C","5BC2E7","2985 C","100","std"],
["PANTONE","2995 C","00A9E0","2995 C","100","std"],
["PANTONE","3005 C","0077C8","3005 C","100","std"],
["PANTONE","3015 C","00629B","3015 C","100","std"],
["PANTONE","3025 C","004F71","3025 C","100","std"],
["PANTONE","3035 C","003D53","3035 C","100","std"],
["PANTONE","7695 C","7BA7BC","7695 C","100","std"],
["PANTONE","7696 C","6399AE","7696 C","100","std"],
["PANTONE","7697 C","4E87A0","7697 C","100","std"],
["PANTONE","7698 C","41748D","7698 C","100","std"],
["PANTONE","7699 C","34657F","7699 C","100","std"],
["PANTONE","7700 C","165C7D","7700 C","100","std"],
["PANTONE","7701 C","005576","7701 C","100","std"],
["PANTONE","7457 C","BBDDE6","7457 C","100","std"],
["PANTONE","7458 C","71B2C9","7458 C","100","std"],
["PANTONE","7459 C","4298B5","7459 C","100","std"],
["PANTONE","7460 C","0086BF","7460 C","100","std"],
["PANTONE","7461 C","007DBA","7461 C","100","std"],
["PANTONE","7462 C","00558C","7462 C","100","std"],
["PANTONE","7463 C","002B49","7463 C","100","std"],
["PANTONE","304 C","9ADBE8","304 C","100","std"],
["PANTONE","305 C","59CBE8","305 C","100","std"],
["PANTONE","306 C","00B5E2","306 C","100","std"],
["PANTONE","307 C","006BA6","307 C","100","std"],
["PANTONE","308 C","00587C","308 C","100","std"],
["PANTONE","309 C","003B49","309 C","100","std"],
["PANTONE","635 C","A4DBE8","635 C","100","std"],
["PANTONE","636 C","8BD3E6","636 C","100","std"],
["PANTONE","637 C","4EC3E0","637 C","100","std"],
["PANTONE","638 C","00AFD7","638 C","100","std"],
["PANTONE","639 C","0095C8","639 C","100","std"],
["PANTONE","640 C","0082BA","640 C","100","std"],
["PANTONE","641 C","0067A0","641 C","100","std"],
["PANTONE","7702 C","48A9C5","7702 C","100","std"],
["PANTONE","7703 C","009CBD","7703 C","100","std"],
["PANTONE","7704 C","0085AD","7704 C","100","std"],
["PANTONE","7705 C","006E96","7705 C","100","std"],
["PANTONE","7706 C","006A8E","7706 C","100","std"],
["PANTONE","7707 C","00617F","7707 C","100","std"],
["PANTONE","7708 C","005571","7708 C","100","std"],
["PANTONE","628 C","B8DDE1","628 C","100","std"],
["PANTONE","629 C","9BD3DD","629 C","100","std"],
["PANTONE","630 C","77C5D5","630 C","100","std"],
["PANTONE","631 C","3EB1C8","631 C","100","std"],
["PANTONE","632 C","0093B2","632 C","100","std"],
["PANTONE","633 C","007196","633 C","100","std"],
["PANTONE","634 C","005F83","634 C","100","std"],
["PANTONE","310 C","6AD1E3","310 C","100","std"],
["PANTONE","311 C","05C3DE","311 C","100","std"],
["PANTONE","312 C","00A9CE","312 C","100","std"],
["PANTONE","313 C","0092BC","313 C","100","std"],
["PANTONE","314 C","007FA3","314 C","100","std"],
["PANTONE","315 C","00677F","315 C","100","std"],
["PANTONE","316 C","004752","316 C","100","std"],
["PANTONE","3105 C","68D2DF","3105 C","100","std"],
["PANTONE","3115 C","00C1D5","3115 C","100","std"],
["PANTONE","3125 C","00AEC7","3125 C","100","std"],
["PANTONE","3135 C","008EAA","3135 C","100","std"],
["PANTONE","3145 C","00778B","3145 C","100","std"],
["PANTONE","3155 C","006074","3155 C","100","std"],
["PANTONE","3165 C","004F59","3165 C","100","std"],
["PANTONE","7709 C","63B1BC","7709 C","100","std"],
["PANTONE","7710 C","00A7B5","7710 C","100","std"],
["PANTONE","7711 C","0097A9","7711 C","100","std"],
["PANTONE","7712 C","00859B","7712 C","100","std"],
["PANTONE","7713 C","007D8A","7713 C","100","std"],
["PANTONE","7714 C","007582","7714 C","100","std"],
["PANTONE","7715 C","00606A","7715 C","100","std"],
["PANTONE","317 C","B1E4E3","317 C","100","std"],
["PANTONE","318 C","88DBDF","318 C","100","std"],
["PANTONE","319 C","2DCCD3","319 C","100","std"],
["PANTONE","320 C","009CA6","320 C","100","std"],
["PANTONE","321 C","008C95","321 C","100","std"],
["PANTONE","322 C","007078","322 C","100","std"],
["PANTONE","323 C","005F61","323 C","100","std"],
["PANTONE","7464 C","A0D1CA","7464 C","100","std"],
["PANTONE","7465 C","40C1AC","7465 C","100","std"],
["PANTONE","7466 C","00B0B9","7466 C","100","std"],
["PANTONE","7467 C","00A3AD","7467 C","100","std"],
["PANTONE","7468 C","007197","7468 C","100","std"],
["PANTONE","7469 C","005F86","7469 C","100","std"],
["PANTONE","7470 C","005A70","7470 C","100","std"],
["PANTONE","7471 C","7EDDD3","7471 C","100","std"],
["PANTONE","7472 C","5CB8B2","7472 C","100","std"],
["PANTONE","7473 C","279989","7473 C","100","std"],
["PANTONE","7474 C","007483","7474 C","100","std"],
["PANTONE","7475 C","487A7B","7475 C","100","std"],
["PANTONE","7476 C","0D5257","7476 C","100","std"],
["PANTONE","7477 C","244C5A","7477 C","100","std"],
["PANTONE","5523 C","B6CFD0","5523 C","100","std"],
["PANTONE","5513 C","ABC7CA","5513 C","100","std"],
["PANTONE","5503 C","94B7BB","5503 C","100","std"],
["PANTONE","5493 C","7FA9AE","5493 C","100","std"],
["PANTONE","5483 C","4F868E","5483 C","100","std"],
["PANTONE","5473 C","035C67","5473 C","100","std"],
["PANTONE","5463 C","07272D","5463 C","100","std"],
["PANTONE","7716 C","00968F","7716 C","100","std"],
["PANTONE","7717 C","00857D","7717 C","100","std"],
["PANTONE","7718 C","007472","7718 C","100","std"],
["PANTONE","7719 C","006D68","7719 C","100","std"],
["PANTONE","7720 C","00635B","7720 C","100","std"],
["PANTONE","7721 C","005E5D","7721 C","100","std"],
["PANTONE","7722 C","004F52","7722 C","100","std"],
["PANTONE","324 C","9CDBD9","324 C","100","std"],
["PANTONE","325 C","64CCC9","325 C","100","std"],
["PANTONE","326 C","00B2A9","326 C","100","std"],
["PANTONE","327 C","008375","327 C","100","std"],
["PANTONE","328 C","007067","328 C","100","std"],
["PANTONE","329 C","00685E","329 C","100","std"],
["PANTONE","330 C","00534C","330 C","100","std"],
["PANTONE","3242 C","71DBD4","3242 C","100","std"],
["PANTONE","3252 C","2AD2C9","3252 C","100","std"],
["PANTONE","3262 C","00BFB3","3262 C","100","std"],
["PANTONE","3272 C","00A499","3272 C","100","std"],
["PANTONE","3282 C","00827A","3282 C","100","std"],
["PANTONE","3292 C","00594F","3292 C","100","std"],
["PANTONE","3302 C","004C45","3302 C","100","std"],
["PANTONE","3245 C","7CE0D3","3245 C","100","std"],
["PANTONE","3255 C","2CD5C4","3255 C","100","std"],
["PANTONE","3265 C","00C7B1","3265 C","100","std"],
["PANTONE","3275 C","00B398","3275 C","100","std"],
["PANTONE","3285 C","009383","3285 C","100","std"],
["PANTONE","3295 C","007567","3295 C","100","std"],
["PANTONE","3305 C","004D43","3305 C","100","std"],
["PANTONE","3248 C","6DCDB8","3248 C","100","std"],
["PANTONE","3258 C","49C5B1","3258 C","100","std"],
["PANTONE","3268 C","00AB8E","3268 C","100","std"],
["PANTONE","3278 C","009B77","3278 C","100","std"],
["PANTONE","3288 C","008065","3288 C","100","std"],
["PANTONE","3298 C","006A52","3298 C","100","std"],
["PANTONE","3308 C","004539","3308 C","100","std"],
["PANTONE","566 C","B9DCD2","566 C","100","std"],
["PANTONE","565 C","A1D6CA","565 C","100","std"],
["PANTONE","564 C","86C8BC","564 C","100","std"],
["PANTONE","563 C","6BBBAE","563 C","100","std"],
["PANTONE","562 C","006F62","562 C","100","std"],
["PANTONE","561 C","00594C","561 C","100","std"],
["PANTONE","560 C","1D3C34","560 C","100","std"],
["PANTONE","573 C","B5E3D8","573 C","100","std"],
["PANTONE","572 C","A5DFD3","572 C","100","std"],
["PANTONE","571 C","98DBCE","571 C","100","std"],
["PANTONE","570 C","6BCABA","570 C","100","std"],
["PANTONE","569 C","00816D","569 C","100","std"],
["PANTONE","568 C","006C5B","568 C","100","std"],
["PANTONE","567 C","173F35","567 C","100","std"],
["PANTONE","559 C","ADCAB8","559 C","100","std"],
["PANTONE","558 C","9ABEAA","558 C","100","std"],
["PANTONE","557 C","85B09A","557 C","100","std"],
["PANTONE","556 C","6FA287","556 C","100","std"],
["PANTONE","555 C","28724F","555 C","100","std"],
["PANTONE","554 C","205C40","554 C","100","std"],
["PANTONE","553 C","284734","553 C","100","std"],
["PANTONE","5595 C","BFCEC2","5595 C","100","std"],
["PANTONE","5585 C","A7BDB1","5585 C","100","std"],
["PANTONE","5575 C","92ACA0","5575 C","100","std"],
["PANTONE","5565 C","7F9C90","5565 C","100","std"],
["PANTONE","5555 C","5C7F71","5555 C","100","std"],
["PANTONE","5545 C","43695B","5545 C","100","std"],
["PANTONE","5535 C","183028","5535 C","100","std"],
["PANTONE","5665 C","BAC5B9","5665 C","100","std"],
["PANTONE","5655 C","B0BDB0","5655 C","100","std"],
["PANTONE","5645 C","A3B2A4","5645 C","100","std"],
["PANTONE","5635 C","94A596","5635 C","100","std"],
["PANTONE","5625 C","708573","5625 C","100","std"],
["PANTONE","5615 C","5E7461","5615 C","100","std"],
["PANTONE","5605 C","22372B","5605 C","100","std"],
["PANTONE","5527 C","BCC9C5","5527 C","100","std"],
["PANTONE","5517 C","B1C0BC","5517 C","100","std"],
["PANTONE","5507 C","9DB0AC","5507 C","100","std"],
["PANTONE","5497 C","829995","5497 C","100","std"],
["PANTONE","5487 C","5D7975","5487 C","100","std"],
["PANTONE","5477 C","3E5D58","5477 C","100","std"],
["PANTONE","5467 C","18332F","5467 C","100","std"],
["PANTONE","621 C","D1E0D7","621 C","100","std"],
["PANTONE","622 C","B7CDC2","622 C","100","std"],
["PANTONE","623 C","9AB9AD","623 C","100","std"],
["PANTONE","624 C","789F90","624 C","100","std"],
["PANTONE","625 C","507F70","625 C","100","std"],
["PANTONE","626 C","285C4D","626 C","100","std"],
["PANTONE","627 C","13322B","627 C","100","std"],
["PANTONE","331 C","A7E6D7","331 C","100","std"],
["PANTONE","332 C","8CE2D0","332 C","100","std"],
["PANTONE","333 C","3CDBC0","333 C","100","std"],
["PANTONE","334 C","009478","334 C","100","std"],
["PANTONE","335 C","007B5F","335 C","100","std"],
["PANTONE","336 C","00664F","336 C","100","std"],
["PANTONE","337 C","8FD6BD","337 C","100","std"],
["PANTONE","338 C","6ECEB2","338 C","100","std"],
["PANTONE","339 C","00B388","339 C","100","std"],
["PANTONE","340 C","00965E","340 C","100","std"],
["PANTONE","341 C","007A53","341 C","100","std"],
["PANTONE","342 C","006547","342 C","100","std"],
["PANTONE","343 C","115740","343 C","100","std"],
["PANTONE","7723 C","50A684","7723 C","100","std"],
["PANTONE","7724 C","00966C","7724 C","100","std"],
["PANTONE","7725 C","008557","7725 C","100","std"],
["PANTONE","7726 C","007B4B","7726 C","100","std"],
["PANTONE","7727 C","006F44","7727 C","100","std"],
["PANTONE","7728 C","006646","7728 C","100","std"],
["PANTONE","7729 C","005645","7729 C","100","std"],
["PANTONE","3375 C","7AE1BF","3375 C","100","std"],
["PANTONE","3385 C","47D7AC","3385 C","100","std"],
["PANTONE","3395 C","00C389","3395 C","100","std"],
["PANTONE","3405 C","00AF66","3405 C","100","std"],
["PANTONE","3415 C","00744B","3415 C","100","std"],
["PANTONE","3425 C","006243","3425 C","100","std"],
["PANTONE","3435 C","154734","3435 C","100","std"],
["PANTONE","344 C","A0DAB3","344 C","100","std"],
["PANTONE","345 C","91D6AC","345 C","100","std"],
["PANTONE","346 C","71CC98","346 C","100","std"],
["PANTONE","347 C","009A44","347 C","100","std"],
["PANTONE","348 C","00843D","348 C","100","std"],
["PANTONE","349 C","046A38","349 C","100","std"],
["PANTONE","350 C","2C5234","350 C","100","std"],
["PANTONE","351 C","A2E4B8","351 C","100","std"],
["PANTONE","352 C","8FE2B0","352 C","100","std"],
["PANTONE","353 C","80E0A7","353 C","100","std"],
["PANTONE","354 C","00B140","354 C","100","std"],
["PANTONE","355 C","00943C","355 C","100","std"],
["PANTONE","356 C","007A33","356 C","100","std"],
["PANTONE","357 C","215732","357 C","100","std"],
["PANTONE","7478 C","9BE3BF","7478 C","100","std"],
["PANTONE","7479 C","26D07C","7479 C","100","std"],
["PANTONE","7480 C","00BF6F","7480 C","100","std"],
["PANTONE","7481 C","00B74F","7481 C","100","std"],
["PANTONE","7482 C","009F4D","7482 C","100","std"],
["PANTONE","7483 C","275D38","7483 C","100","std"],
["PANTONE","7484 C","00573F","7484 C","100","std"],
["PANTONE","7730 C","4B9560","7730 C","100","std"],
["PANTONE","7731 C","228848","7731 C","100","std"],
["PANTONE","7732 C","007A3E","7732 C","100","std"],
["PANTONE","7733 C","006E42","7733 C","100","std"],
["PANTONE","7734 C","286140","7734 C","100","std"],
["PANTONE","7735 C","36573B","7735 C","100","std"],
["PANTONE","7736 C","395542","7736 C","100","std"],
["PANTONE","7737 C","6BA539","7737 C","100","std"],
["PANTONE","7738 C","48A23F","7738 C","100","std"],
["PANTONE","7739 C","319B42","7739 C","100","std"],
["PANTONE","7740 C","3A913F","7740 C","100","std"],
["PANTONE","7741 C","44883E","7741 C","100","std"],
["PANTONE","7742 C","4A773C","7742 C","100","std"],
["PANTONE","7743 C","44693D","7743 C","100","std"],
["PANTONE","358 C","ADDC91","358 C","100","std"],
["PANTONE","359 C","A1D884","359 C","100","std"],
["PANTONE","360 C","6CC24A","360 C","100","std"],
["PANTONE","361 C","43B02A","361 C","100","std"],
["PANTONE","362 C","509E2F","362 C","100","std"],
["PANTONE","363 C","4C8C2B","363 C","100","std"],
["PANTONE","364 C","4A7729","364 C","100","std"],
["PANTONE","7485 C","D0DEBB","7485 C","100","std"],
["PANTONE","7486 C","BCE194","7486 C","100","std"],
["PANTONE","7487 C","8EDD65","7487 C","100","std"],
["PANTONE","7488 C","78D64B","7488 C","100","std"],
["PANTONE","7489 C","74AA50","7489 C","100","std"],
["PANTONE","7490 C","719949","7490 C","100","std"],
["PANTONE","7491 C","79863C","7491 C","100","std"],
["PANTONE","365 C","C2E189","365 C","100","std"],
["PANTONE","366 C","B7DD79","366 C","100","std"],
["PANTONE","367 C","A4D65E","367 C","100","std"],
["PANTONE","368 C","78BE20","368 C","100","std"],
["PANTONE","369 C","64A70B","369 C","100","std"],
["PANTONE","370 C","658D1B","370 C","100","std"],
["PANTONE","371 C","546223","371 C","100","std"],
["PANTONE","372 C","D4EB8E","372 C","100","std"],
["PANTONE","373 C","CDEA80","373 C","100","std"],
["PANTONE","374 C","C5E86C","374 C","100","std"],
["PANTONE","375 C","97D700","375 C","100","std"],
["PANTONE","376 C","84BD00","376 C","100","std"],
["PANTONE","377 C","7A9A01","377 C","100","std"],
["PANTONE","378 C","59621D","378 C","100","std"],
["PANTONE","580 C","C4D6A4","580 C","100","std"],
["PANTONE","579 C","BCD19B","579 C","100","std"],
["PANTONE","578 C","B7CE95","578 C","100","std"],
["PANTONE","577 C","A9C47F","577 C","100","std"],
["PANTONE","576 C","789D4A","576 C","100","std"],
["PANTONE","575 C","67823A","575 C","100","std"],
["PANTONE","574 C","4E5B31","574 C","100","std"],
["PANTONE","5807 C","D0D1AB","5807 C","100","std"],
["PANTONE","5797 C","C6C89B","5797 C","100","std"],
["PANTONE","5787 C","BABD8B","5787 C","100","std"],
["PANTONE","5777 C","A2A569","5777 C","100","std"],
["PANTONE","5767 C","8A8D4A","5767 C","100","std"],
["PANTONE","5757 C","6D712E","5757 C","100","std"],
["PANTONE","5747 C","3D441E","5747 C","100","std"],
["PANTONE","5875 C","D2CE9E","5875 C","100","std"],
["PANTONE","5865 C","CBC793","5865 C","100","std"],
["PANTONE","5855 C","C0BB87","5855 C","100","std"],
["PANTONE","5845 C","AFA96E","5845 C","100","std"],
["PANTONE","5835 C","A09958","5835 C","100","std"],
["PANTONE","5825 C","89813D","5825 C","100","std"],
["PANTONE","5815 C","555025","5815 C","100","std"],
["PANTONE","5803 C","C3C6A8","5803 C","100","std"],
["PANTONE","5793 C","B3B995","5793 C","100","std"],
["PANTONE","5783 C","A3AA83","5783 C","100","std"],
["PANTONE","5773 C","899064","5773 C","100","std"],
["PANTONE","5763 C","737B4C","5763 C","100","std"],
["PANTONE","5753 C","5E6738","5753 C","100","std"],
["PANTONE","5743 C","3E4827","5743 C","100","std"],
["PANTONE","7492 C","BFCC80","7492 C","100","std"],
["PANTONE","7493 C","BBC592","7493 C","100","std"],
["PANTONE","7494 C","9CAF88","7494 C","100","std"],
["PANTONE","7495 C","8F993E","7495 C","100","std"],
["PANTONE","7496 C","76881D","7496 C","100","std"],
["PANTONE","7497 C","7A7256","7497 C","100","std"],
["PANTONE","7498 C","5B6236","7498 C","100","std"],
["PANTONE","7744 C","BABC16","7744 C","100","std"],
["PANTONE","7745 C","ABAD23","7745 C","100","std"],
["PANTONE","7746 C","999B30","7746 C","100","std"],
["PANTONE","7747 C","888D30","7747 C","100","std"],
["PANTONE","7748 C","7C8034","7748 C","100","std"],
["PANTONE","7749 C","727337","7749 C","100","std"],
["PANTONE","7750 C","656635","7750 C","100","std"],
["PANTONE","379 C","E2E868","379 C","100","std"],
["PANTONE","380 C","DBE442","380 C","100","std"],
["PANTONE","381 C","CEDC00","381 C","100","std"],
["PANTONE","382 C","C4D600","382 C","100","std"],
["PANTONE","383 C","A8AD00","383 C","100","std"],
["PANTONE","384 C","949300","384 C","100","std"],
["PANTONE","385 C","787121","385 C","100","std"],
["PANTONE","386 C","E9EC6B","386 C","100","std"],
["PANTONE","387 C","E3E935","387 C","100","std"],
["PANTONE","388 C","E0E721","388 C","100","std"],
["PANTONE","389 C","D0DF00","389 C","100","std"],
["PANTONE","390 C","B5BD00","390 C","100","std"],
["PANTONE","391 C","9A9500","391 C","100","std"],
["PANTONE","392 C","827A04","392 C","100","std"],
["PANTONE","587 C","E3E48D","587 C","100","std"],
["PANTONE","586 C","E0E27C","586 C","100","std"],
["PANTONE","585 C","DBDE70","585 C","100","std"],
["PANTONE","584 C","D2D755","584 C","100","std"],
["PANTONE","583 C","B7BF10","583 C","100","std"],
["PANTONE","582 C","8E8C13","582 C","100","std"],
["PANTONE","581 C","625D20","581 C","100","std"],
["PANTONE","393 C","F0EC74","393 C","100","std"],
["PANTONE","394 C","EDE939","394 C","100","std"],
["PANTONE","395 C","ECE81A","395 C","100","std"],
["PANTONE","396 C","E1E000","396 C","100","std"],
["PANTONE","397 C","BFB800","397 C","100","std"],
["PANTONE","398 C","ADA400","398 C","85","std"],
["PANTONE","399 C","A09200","399 C","90","std"],
["PANTONE","3935 C","F3EA5D","3935 C","100","std"],
["PANTONE","3945 C","F3E500","3945 C","100","std"],
["PANTONE","3955 C","EFDF00","3955 C","100","std"],
["PANTONE","3965 C","EEDC00","3965 C","100","std"],
["PANTONE","3975 C","BBA600","3975 C","100","std"],
["PANTONE","3985 C","9A8700","3985 C","100","std"],
["PANTONE","3995 C","685C20","3995 C","100","std"],
["PANTONE","600 C","F1EB9C","600 C","100","std"],
["PANTONE","601 C","F0E991","601 C","100","std"],
["PANTONE","602 C","F0E87B","602 C","100","std"],
["PANTONE","603 C","EDE04B","603 C","100","std"],
["PANTONE","604 C","EADA24","604 C","100","std"],
["PANTONE","605 C","E1CD00","605 C","100","std"],
["PANTONE","606 C","CFB500","606 C","100","std"],
["PANTONE","607 C","EBE49A","607 C","100","std"],
["PANTONE","608 C","E9E186","608 C","100","std"],
["PANTONE","609 C","E6DE77","609 C","100","std"],
["PANTONE","610 C","E1D555","610 C","100","std"],
["PANTONE","611 C","D7C826","611 C","100","std"],
["PANTONE","612 C","C4B000","612 C","100","std"],
["PANTONE","613 C","B39B00","613 C","100","std"],
["PANTONE","461 C","E9DF97","461 C","100","std"],
["PANTONE","460 C","E4D77E","460 C","100","std"],
["PANTONE","459 C","DECD63","459 C","100","std"],
["PANTONE","458 C","D9C756","458 C","100","std"],
["PANTONE","457 C","B89D18","457 C","100","std"],
["PANTONE","456 C","A28E2A","456 C","100","std"],
["PANTONE","455 C","695B24","455 C","100","std"],
["PANTONE","614 C","DCD59A","614 C","100","std"],
["PANTONE","615 C","D6CF8D","615 C","100","std"],
["PANTONE","616 C","D0C883","616 C","100","std"],
["PANTONE","617 C","C0B561","617 C","100","std"],
["PANTONE","618 C","AC9F3C","618 C","100","std"],
["PANTONE","619 C","9F912A","619 C","100","std"],
["PANTONE","620 C","8A7B19","620 C","100","std"],
["PANTONE","7751 C","CAB64B","7751 C","100","std"],
["PANTONE","7752 C","CFB023","7752 C","100","std"],
["PANTONE","7753 C","C1A01E","7753 C","100","std"],
["PANTONE","7754 C","A08629","7754 C","100","std"],
["PANTONE","7755 C","897630","7755 C","100","std"],
["PANTONE","7756 C","736635","7756 C","100","std"],
["PANTONE","7757 C","665D33","7757 C","100","std"],
["PANTONE","7758 C","D4C304","7758 C","100","std"],
["PANTONE","7759 C","C4B200","7759 C","100","std"],
["PANTONE","7760 C","91852C","7760 C","100","std"],
["PANTONE","7761 C","747136","7761 C","100","std"],
["PANTONE","7762 C","5D6439","7762 C","100","std"],
["PANTONE","7763 C","585C3B","7763 C","100","std"],
["PANTONE","7764 C","535435","7764 C","100","std"],
["PANTONE","7765 C","BBB323","7765 C","100","std"],
["PANTONE","7766 C","B4A91F","7766 C","100","std"],
["PANTONE","7767 C","AA9D2E","7767 C","100","std"],
["PANTONE","7768 C","8F7E35","7768 C","100","std"],
["PANTONE","7769 C","716135","7769 C","100","std"],
["PANTONE","7770 C","635939","7770 C","100","std"],
["PANTONE","7771 C","4E4934","7771 C","100","std"],
["PANTONE","4545 C","D5CB9F","4545 C","100","std"],
["PANTONE","4535 C","CFC493","4535 C","100","std"],
["PANTONE","4525 C","C5B783","4525 C","100","std"],
["PANTONE","4515 C","B3A369","4515 C","100","std"],
["PANTONE","4505 C","998542","4505 C","100","std"],
["PANTONE","4495 C","8C7732","4495 C","100","std"],
["PANTONE","4485 C","614F25","4485 C","100","std"],
["PANTONE","454 C","CAC7A7","454 C","100","std"],
["PANTONE","453 C","BFBB98","453 C","100","std"],
["PANTONE","452 C","B0AA7E","452 C","100","std"],
["PANTONE","451 C","9B945F","451 C","100","std"],
["PANTONE","450 C","594A25","450 C","100","std"],
["PANTONE","449 C","524727","449 C","100","std"],
["PANTONE","448 C","4A412A","448 C","100","std"],
["PANTONE","7499 C","F1E6B2","7499 C","100","std"],
["PANTONE","7500 C","DFD1A7","7500 C","100","std"],
["PANTONE","7501 C","D9C89E","7501 C","100","std"],
["PANTONE","7502 C","CEB888","7502 C","100","std"],
["PANTONE","7503 C","A89968","7503 C","100","std"],
["PANTONE","7504 C","94795D","7504 C","100","std"],
["PANTONE","7505 C","816040","7505 C","100","std"],
["PANTONE","468 C","DDCBA4","468 C","100","std"],
["PANTONE","467 C","D3BC8D","467 C","100","std"],
["PANTONE","466 C","C6AA76","466 C","100","std"],
["PANTONE","465 C","B9975B","465 C","100","std"],
["PANTONE","464 C","8B5B29","464 C","100","std"],
["PANTONE","463 C","744F28","463 C","100","std"],
["PANTONE","462 C","5C462B","462 C","100","std"],
["PANTONE","7506 C","EFDBB2","7506 C","100","std"],
["PANTONE","7507 C","FCD299","7507 C","100","std"],
["PANTONE","7508 C","E1B87F","7508 C","100","std"],
["PANTONE","7509 C","D6A461","7509 C","100","std"],
["PANTONE","7510 C","C6893F","7510 C","100","std"],
["PANTONE","7511 C","B77729","7511 C","100","std"],
["PANTONE","7512 C","A6631B","7512 C","100","std"],
["PANTONE","719 C","EDC8A3","719 C","100","std"],
["PANTONE","720 C","E7B78A","720 C","100","std"],
["PANTONE","721 C","DDA46F","721 C","100","std"],
["PANTONE","722 C","C88242","722 C","100","std"],
["PANTONE","723 C","B36924","723 C","100","std"],
["PANTONE","724 C","934D11","724 C","100","std"],
["PANTONE","725 C","7D3F16","725 C","100","std"],
["PANTONE","475 C","F3CFB3","475 C","100","std"],
["PANTONE","474 C","F1C6A7","474 C","100","std"],
["PANTONE","473 C","F0BF9B","473 C","100","std"],
["PANTONE","472 C","E59E6D","472 C","100","std"],
["PANTONE","471 C","B86125","471 C","100","std"],
["PANTONE","470 C","A45A2A","470 C","100","std"],
["PANTONE","469 C","693F23","469 C","100","std"],
["PANTONE","726 C","E0C09F","726 C","100","std"],
["PANTONE","727 C","D9B48F","727 C","100","std"],
["PANTONE","728 C","CDA077","728 C","100","std"],
["PANTONE","729 C","B58150","729 C","100","std"],
["PANTONE","730 C","9E652E","730 C","100","std"],
["PANTONE","731 C","774212","731 C","100","std"],
["PANTONE","732 C","623412","732 C","100","std"],
["PANTONE","4685 C","E0C6AD","4685 C","100","std"],
["PANTONE","4675 C","DCBFA6","4675 C","100","std"],
["PANTONE","4665 C","CDA788","4665 C","100","std"],
["PANTONE","4655 C","BF9474","4655 C","100","std"],
["PANTONE","4645 C","AD7C59","4645 C","100","std"],
["PANTONE","4635 C","946037","4635 C","100","std"],
["PANTONE","4625 C","4F2C1D","4625 C","100","std"],
["PANTONE","7513 C","E1B7A7","7513 C","100","std"],
["PANTONE","7514 C","D5A286","7514 C","100","std"],
["PANTONE","7515 C","C58B68","7515 C","100","std"],
["PANTONE","7516 C","99552B","7516 C","100","std"],
["PANTONE","7517 C","85431E","7517 C","100","std"],
["PANTONE","7518 C","6D4F47","7518 C","100","std"],
["PANTONE","7519 C","5E4B3C","7519 C","100","std"],
["PANTONE","4755 C","D7C4B7","4755 C","100","std"],
["PANTONE","4745 C","CDB5A7","4745 C","100","std"],
["PANTONE","4735 C","C0A392","4735 C","100","std"],
["PANTONE","4725 C","AE8A79","4725 C","100","std"],
["PANTONE","4715 C","956C58","4715 C","100","std"],
["PANTONE","4705 C","7C4D3A","4705 C","100","std"],
["PANTONE","4695 C","5B3427","4695 C","100","std"],
["PANTONE","482 C","DBC8B6","482 C","100","std"],
["PANTONE","481 C","D3BBA8","481 C","100","std"],
["PANTONE","480 C","C6A992","480 C","100","std"],
["PANTONE","479 C","AA8066","479 C","100","std"],
["PANTONE","478 C","703F2A","478 C","100","std"],
["PANTONE","477 C","623B2A","477 C","100","std"],
["PANTONE","476 C","4E3629","476 C","100","std"],
["PANTONE","7527 C","D6D2C4","7527 C","100","std"],
["PANTONE","7528 C","C5B9AC","7528 C","100","std"],
["PANTONE","7529 C","B7A99A","7529 C","100","std"],
["PANTONE","7530 C","A39382","7530 C","100","std"],
["PANTONE","7531 C","7A6855","7531 C","100","std"],
["PANTONE","7532 C","63513D","7532 C","100","std"],
["PANTONE","7533 C","473729","7533 C","100","std"],
["PANTONE","7534 C","D1CCBD","7534 C","100","std"],
["PANTONE","7535 C","B7B09C","7535 C","100","std"],
["PANTONE","7536 C","A69F88","7536 C","100","std"],
["PANTONE","7537 C","A7ACA2","7537 C","100","std"],
["PANTONE","7538 C","949A90","7538 C","100","std"],
["PANTONE","7539 C","8E9089","7539 C","100","std"],
["PANTONE","7540 C","4B4F54","7540 C","100","std"],
["PANTONE","427 C","D0D3D4","427 C","100","std"],
["PANTONE","428 C","C1C6C8","428 C","100","std"],
["PANTONE","429 C","A2AAAD","429 C","100","std"],
["PANTONE","430 C","7C878E","430 C","100","std"],
["PANTONE","431 C","5B6770","431 C","100","std"],
["PANTONE","432 C","333F48","432 C","100","std"],
["PANTONE","433 C","1D252D","433 C","100","std"],
["PANTONE","420 C","C7C9C7","420 C","100","std"],
["PANTONE","421 C","B2B4B2","421 C","100","std"],
["PANTONE","422 C","9EA2A2","422 C","100","std"],
["PANTONE","423 C","898D8D","423 C","100","std"],
["PANTONE","424 C","707372","424 C","100","std"],
["PANTONE","425 C","54585A","425 C","100","std"],
["PANTONE","426 C","25282A","426 C","100","std"],
["PANTONE","441 C","BEC6C4","441 C","100","std"],
["PANTONE","442 C","A2ACAB","442 C","100","std"],
["PANTONE","443 C","919D9D","443 C","100","std"],
["PANTONE","444 C","717C7D","444 C","100","std"],
["PANTONE","445 C","505759","445 C","100","std"],
["PANTONE","446 C","3F4444","446 C","100","std"],
["PANTONE","447 C","373A36","447 C","100","std"],
["PANTONE","413 C","BABBB1","413 C","100","std"],
["PANTONE","414 C","A8A99E","414 C","100","std"],
["PANTONE","415 C","919388","415 C","100","std"],
["PANTONE","416 C","7E7F74","416 C","100","std"],
["PANTONE","417 C","65665C","417 C","100","std"],
["PANTONE","418 C","51534A","418 C","100","std"],
["PANTONE","419 C","212322","419 C","100","std"],
["PANTONE","400 C","C4BFB6","400 C","100","std"],
["PANTONE","401 C","AFA9A0","401 C","100","std"],
["PANTONE","402 C","9D968D","402 C","100","std"],
["PANTONE","403 C","8C857B","403 C","100","std"],
["PANTONE","404 C","766E65","404 C","100","std"],
["PANTONE","405 C","696158","405 C","100","std"],
["PANTONE","406 C","C4BCB7","406 C","100","std"],
["PANTONE","407 C","B2A8A2","407 C","100","std"],
["PANTONE","408 C","978C87","408 C","100","std"],
["PANTONE","409 C","857874","409 C","100","std"],
["PANTONE","410 C","746661","410 C","100","std"],
["PANTONE","411 C","5E514D","411 C","100","std"],
["PANTONE","412 C","382F2D","412 C","100","std"],
["PANTONE","434 C","D0C4C5","434 C","100","std"],
["PANTONE","435 C","C1B2B6","435 C","100","std"],
["PANTONE","436 C","AB989D","436 C","100","std"],
["PANTONE","437 C","7B6469","437 C","100","std"],
["PANTONE","438 C","584446","438 C","100","std"],
["PANTONE","439 C","453536","439 C","100","std"],
["PANTONE","440 C","382E2C","440 C","100","std"],
["PANTONE","Warm Gray 1 C","D7D2CB","Warm Gray 1 C","100","std"],
["PANTONE","Warm Gray 2 C","CBC4BC","Warm Gray 2 C","100","std"],
["PANTONE","Warm Gray 3 C","BFB8AF","Warm Gray 3 C","100","std"],
["PANTONE","Warm Gray 4 C","B6ADA5","Warm Gray 4 C","100","std"],
["PANTONE","Warm Gray 5 C","ACA39A","Warm Gray 5 C","100","std"],
["PANTONE","Warm Gray 6 C","A59C94","Warm Gray 6 C","100","std"],
["PANTONE","Warm Gray 7 C","968C83","Warm Gray 7 C","100","std"],
["PANTONE","Warm Gray 8 C","8C8279","Warm Gray 8 C","100","std"],
["PANTONE","Warm Gray 9 C","83786F","Warm Gray 9 C","100","std"],
["PANTONE","Warm Gray 10 C","776D65","Warm Gray 10 C","100","std"],
["PANTONE","Warm Gray 11 C","6E6259","Warm Gray 11 C","100","std"],
["PANTONE","Cool Gray 1 C","D9D9D6","Cool Gray 1 C","100","std"],
["PANTONE","Cool Gray 2 C","D0D0CE","Cool Gray 2 C","100","std"],
["PANTONE","Cool Gray 3 C","C8C9C7","Cool Gray 3 C","100","std"],
["PANTONE","Cool Gray 4 C","BBBCBC","Cool Gray 4 C","100","std"],
["PANTONE","Cool Gray 5 C","B1B3B3","Cool Gray 5 C","100","std"],
["PANTONE","Cool Gray 6 C","A7A8AA","Cool Gray 6 C","100","std"],
["PANTONE","Cool Gray 7 C","97999B","Cool Gray 7 C","100","std"],
["PANTONE","Cool Gray 8 C","888B8D","Cool Gray 8 C","100","std"],
["PANTONE","Cool Gray 9 C","75787B","Cool Gray 9 C","100","std"],
["PANTONE","Cool Gray 10 C","63666A","Cool Gray 10 C","100","std"],
["PANTONE","Cool Gray 11 C","53565A","Cool Gray 11 C","100","std"],
["PANTONE","Black 2 C","332F21","Black 2 C","100","std"],
["PANTONE","Black 3 C","212721","Black 3 C","100","std"],
["PANTONE","Black 4 C","31261D","Black 4 C","100","std"],
["PANTONE","Black 5 C","3E2B2E","Black 5 C","100","std"],
["PANTONE","Black 6 C","101820","Black 6 C","100","std"],
["PANTONE","Black 7 C","3D3935","Black 7 C","100","std"] ];
